/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * SSO provider kinds supported by EXO.<p>Possible values:</p>
 * <ul>
 * <li><b>Entra</b>: Microsoft Entra.</li>
 * <li><b>Authentik</b>: Authentik.</li>
 * </ul>
 */
export enum SsoClientSsoProviderKind {
  Entra = "Entra",
  Authentik = "Authentik",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum LogLevel {
  Trace = "Trace",
  Debug = "Debug",
  Information = "Information",
  Warning = "Warning",
  Error = "Error",
  Critical = "Critical",
  None = "None",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum EncodingSchema {
  SGTIN96 = "SGTIN96",
  CD128 = "CD128",
  StarkV6 = "StarkV6",
  S1 = "S1",
  EXOv2 = "EXOv2",
  RCGEN2 = "RCGEN2",
  TrueVUE = "TrueVUE",
  Fanatics = "Fanatics",
  RCGEN3 = "RCGEN3",
  Cueto = "Cueto",
  Senitron = "Senitron",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum DataEnumerationsUiHint {
  None = "None",
  Boolean = "Boolean",
  DateTime = "DateTime",
  Decimal = "Decimal",
  Double = "Double",
  Int = "Int",
  String = "String",
  Encrypted = "Encrypted",
  StringSelect = "StringSelect",
  Time = "Time",
  Html = "Html",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * <li><b>Import</b>: Import</li>
 * <li><b>Order</b>: Order</li>
 * <li><b>Transaction</b>: Transaction</li>
 * <li><b>Payment</b>: Payment</li>
 * </ul>
 */
export enum DataEnumerationsSystemMessageType {
  Import = "Import",
  Order = "Order",
  Transaction = "Transaction",
  Payment = "Payment",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * <li><b>Error</b>: Error</li>
 * <li><b>Information</b>: Information</li>
 * <li><b>Warning</b>: Warning</li>
 * </ul>
 */
export enum DataEnumerationsSystemMessageLevel {
  Error = "Error",
  Information = "Information",
  Warning = "Warning",
}

/**
 * StationType<p>Possible values:</p>
 * <ul>
 * <li><b>Sale</b>: Sales station</li>
 * <li><b>Validator</b>: Validator</li>
 * </ul>
 */
export enum DataEnumerationsStationType {
  Sale = "Sale",
  Validator = "Validator",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * <li><b>Ready</b>: The station is ready to process a new order.</li>
 * <li><b>InUse</b>: The station is in use and has an active order.</li>
 * <li><b>Resting</b>: The station is at rest and will not respond to items placed into it.</li>
 * <li><b>Disabled</b>: The station is deactivated and not available for use.</li>
 * <li><b>Disconnected</b>: The station is not reachable over the network.</li>
 * <li><b>Diagnostic</b>: Unused</li>
 * <li><b>AssistanceNeeded</b>: A shopper has requested help during the course of a sale.</li>
 * <li><b>ShopperAssistance</b>: A clerk is assisting a shopper with a sale.</li>
 * <li><b>Maintenance</b>: Unused</li>
 * <li><b>RegisteredAwaitingConnection</b>: The station is in the process of pairing with the physical hardware</li>
 * </ul>
 */
export enum DataEnumerationsStationStatus {
  Ready = "Ready",
  InUse = "InUse",
  Resting = "Resting",
  Disabled = "Disabled",
  Disconnected = "Disconnected",
  Diagnostic = "Diagnostic",
  AssistanceNeeded = "AssistanceNeeded",
  ShopperAssistance = "ShopperAssistance",
  Maintenance = "Maintenance",
  RegisteredAwaitingConnection = "RegisteredAwaitingConnection",
}

/**
 * Represents the different operational modes that a station can be in,
 * affecting its behavior, functionality, and interactions within the system.<p>Possible values:</p>
 * <ul>
 * <li><b>Unregistered</b>: Indicates that the station is not registered or initialized in the system.</li>
 * <li><b>Diagnostic</b>: The station is in a diagnostic mode for troubleshooting or testing purposes.</li>
 * <li><b>Resting</b>: The station is in a resting state, possibly indicating it's not in active use but is ready.</li>
 * <li><b>Disabled</b>: The station is disabled and cannot perform its normal operations.</li>
 * <li><b>ShopperAssistance</b>: The station is in shopper assistance mode, possibly providing help or guidance to customers.</li>
 * <li><b>ReadySales</b>: The station is ready for sales operations, awaiting customer interactions for sales.</li>
 * <li><b>ReadyValidator</b>: The station is ready with its validation functionalities, awaiting items or inputs for validation.</li>
 * <li><b>Maintenance</b>: The station is undergoing maintenance, indicating it's temporarily unavailable for standard operations.</li>
 * <li><b>Normal</b>: The station is undergoing maintenance, indicating it's temporarily unavailable for standard operations.</li>
 * </ul>
 */
export enum DataEnumerationsStationMode {
  Unregistered = "Unregistered",
  Diagnostic = "Diagnostic",
  Resting = "Resting",
  Disabled = "Disabled",
  ShopperAssistance = "ShopperAssistance",
  ReadySales = "ReadySales",
  ReadyValidator = "ReadyValidator",
  Maintenance = "Maintenance",
  Normal = "Normal",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum DataEnumerationsStationAlert {
  ShopperAssistance = "ShopperAssistance",
  InputRequired = "InputRequired",
  AssistanceNeeded = "AssistanceNeeded",
}

/**
 * Secret-free categories describing why Shopify offline-token refresh failed.<p>Possible values:</p>
 * <ul>
 * <li><b>None</b>: No failure has been recorded.</li>
 * <li><b>MissingRefreshMetadata</b>: Required refresh-token metadata was absent or malformed.</li>
 * <li><b>RefreshTokenExpired</b>: The stored refresh token expired before it could be exchanged.</li>
 * <li><b>InactiveRefreshToken</b>: Shopify reported that the refresh token is no longer active.</li>
 * <li><b>NetworkError</b>: The outbound request failed at the network layer.</li>
 * <li><b>Timeout</b>: The outbound request timed out.</li>
 * <li><b>RateLimited</b>: Shopify rate-limited the token exchange.</li>
 * <li><b>ShopifyUnavailable</b>: Shopify returned a server-side failure.</li>
 * <li><b>InvalidResponse</b>: Shopify returned an unusable or unexpected response.</li>
 * </ul>
 */
export enum DataEnumerationsShopifyTokenRefreshFailureCategory {
  None = "None",
  MissingRefreshMetadata = "MissingRefreshMetadata",
  RefreshTokenExpired = "RefreshTokenExpired",
  InactiveRefreshToken = "InactiveRefreshToken",
  NetworkError = "NetworkError",
  Timeout = "Timeout",
  RateLimited = "RateLimited",
  ShopifyUnavailable = "ShopifyUnavailable",
  InvalidResponse = "InvalidResponse",
}

/**
 * Shopify application installation lifecycle state.<p>Possible values:</p>
 * <ul>
 * <li><b>None</b>: No installation lifecycle status has been assigned.</li>
 * <li><b>Installed</b>: The Shopify application is installed on the shop.</li>
 * <li><b>Uninstalled</b>: The Shopify shop has uninstalled the EXO Shopify app.</li>
 * <li><b>Revoked</b>: Shopify access for this installation has been revoked.</li>
 * </ul>
 */
export enum DataEnumerationsShopifyInstallationStatus {
  None = "None",
  Installed = "Installed",
  Uninstalled = "Uninstalled",
  Revoked = "Revoked",
}

/**
 * EXO client-link state for a Shopify installation.<p>Possible values:</p>
 * <ul>
 * <li><b>Unlinked</b>: The Shopify installation is not linked to an EXO client.</li>
 * <li><b>Linked</b>: The Shopify installation is linked to an EXO client.</li>
 * <li><b>RequiresRelink</b>: The previous EXO client link must be established again.</li>
 * </ul>
 */
export enum DataEnumerationsShopifyInstallationLinkStatus {
  Unlinked = "Unlinked",
  Linked = "Linked",
  RequiresRelink = "RequiresRelink",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum DataEnumerationsServiceAccountType {
  Other = "Other",
  Sms = "Sms",
  Smtp = "Smtp",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * <li><b>Completed</b>: Completed</li>
 * <li><b>Failed</b>: Failed</li>
 * <li><b>Aborted</b>: Status signifying Import has been Aborted</li>
 * </ul>
 */
export enum DataEnumerationsProductImportStatus {
  None = "None",
  Completed = "Completed",
  Failed = "Failed",
  Initiated = "Initiated",
  InitialValidation = "InitialValidation",
  Queued = "Queued",
  Canceled = "Canceled",
  SecondaryValidation = "SecondaryValidation",
  SavingData = "SavingData",
  SavingResults = "SavingResults",
  FetchingFromPos = "FetchingFromPos",
  TransformingData = "TransformingData",
  Aborted = "Aborted",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * <li><b>None</b>: None</li>
 * <li><b>Appetize</b>: Appetize</li>
 * <li><b>Centarro</b>: Centarro</li>
 * <li><b>RetailCloud</b>: RetailCloud</li>
 * <li><b>Square</b>: Square</li>
 * <li><b>NSPOS</b>: Netsuite</li>
 * <li><b>Demo</b>: Demo</li>
 * <li><b>RetailPro</b>: RetailPro</li>
 * <li><b>TeamworkCommerce</b>: Teamwork Commerce</li>
 * <li><b>OpSuite</b>: OpSuite</li>
 * <li><b>BestRing</b>: BestRing</li>
 * <li><b>SumUp</b>: SumUp</li>
 * <li><b>Cueto</b>: Cueto</li>
 * <li><b>Ronin</b>: Ronin</li>
 * <li><b>MCR</b>: MCR</li>
 * <li><b>AtVenu</b>: AtVenu</li>
 * <li><b>Treez</b>: Treez</li>
 * <li><b>Stripe</b>: Stripe</li>
 * </ul>
 */
export enum DataEnumerationsPosSystem {
  None = "None",
  Appetize = "Appetize",
  Centarro = "Centarro",
  RetailCloud = "RetailCloud",
  Square = "Square",
  NSPOS = "NSPOS",
  Demo = "Demo",
  RetailPro = "RetailPro",
  TeamworkCommerce = "TeamworkCommerce",
  OpSuite = "OpSuite",
  BestRing = "BestRing",
  SumUp = "SumUp",
  Cueto = "Cueto",
  Ronin = "Ronin",
  MCR = "MCR",
  AtVenu = "AtVenu",
  Treez = "Treez",
  Stripe = "Stripe",
}

/**
 * Defines the various states an order can be in<p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum DataEnumerationsOrderStatus {
  None = "None",
  Open = "Open",
  Closed = "Closed",
  Tender = "Tender",
  Hold = "Hold",
  Cancelled = "Cancelled",
  Returned = "Returned",
  CancelledByReset = "CancelledByReset",
  Complete = "Complete",
  Suspended = "Suspended",
  Refunded = "Refunded",
  Review = "Review",
  Payment = "Payment",
  Paid = "Paid",
}

/**
 * Identifies an explicitly configured loyalty-program provider.<p>Possible values:</p>
 * <ul>
 * <li><b>YinzCam</b>: YinzCam loyalty services.</li>
 * <li><b>Shopify</b>: Shopify customer and loyalty services.</li>
 * </ul>
 */
export enum DataEnumerationsLoyaltyProgramProvider {
  YinzCam = "YinzCam",
  Shopify = "Shopify",
}

/**
 * Describes when a discount-code or loyalty-program lookup is available and required.<p>Possible values:</p>
 * <ul>
 * <li><b>Disabled</b>: The feature is unavailable and never blocks checkout.</li>
 * <li><b>RequiredPreOrder</b>: The lookup must succeed before the patron can begin shopping.</li>
 * <li><b>OptionalPreOrderRequiredAtCheckout</b>: The lookup is offered before shopping and becomes required before Review.</li>
 * <li><b>RequiredAtCheckout</b>: The lookup must succeed before the order can move to Review.</li>
 * <li><b>OptionalPostAttract</b>: The lookup is optionally available after the attract screen.</li>
 * </ul>
 */
export enum DataEnumerationsLookupMode {
  Disabled = "Disabled",
  RequiredPreOrder = "RequiredPreOrder",
  OptionalPreOrderRequiredAtCheckout = "OptionalPreOrderRequiredAtCheckout",
  RequiredAtCheckout = "RequiredAtCheckout",
  OptionalPostAttract = "OptionalPostAttract",
}

/**
 * Identifies the value collected for a customer lookup.<p>Possible values:</p>
 * <ul>
 * <li><b>Phone</b>: A customer phone number.</li>
 * <li><b>Email</b>: A customer email address.</li>
 * <li><b>DiscountCode</b>: A customer discount code</li>
 * </ul>
 */
export enum DataEnumerationsLookupInputType {
  Phone = "Phone",
  Email = "Email",
  DiscountCode = "DiscountCode",
}

/**
 * The status of the tracked item<p>Possible values:</p>
 * <ul>
 * <li><b>None</b>: No status</li>
 * <li><b>ExoPurchase</b>: Item was purchased at an Exo station</li>
 * <li><b>ExternalPurchase</b>: For items that were purchased outside Exo</li>
 * <li><b>Ignore</b>: For items that should be ignored</li>
 * <li><b>Alert</b>: For items that should trigger an alert</li>
 * </ul>
 */
export enum DataEnumerationsItemTrackerStatus {
  None = "None",
  ExoPurchase = "ExoPurchase",
  ExternalPurchase = "ExternalPurchase",
  Ignore = "Ignore",
  Alert = "Alert",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * <li><b>Purchased</b>: The item was included in a completed sale and the order is now closed.</li>
 * <li><b>Voided</b>: The item is marked as Void and no longer included in the sale.</li>
 * <li><b>Returned</b>: The item was previously purchased but has been returned.</li>
 * <li><b>New</b>: The item will be included in the order, which is still open.</li>
 * </ul>
 */
export enum DataEnumerationsItemStatus {
  Purchased = "Purchased",
  Voided = "Voided",
  Returned = "Returned",
  New = "New",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * <li><b>New</b>: The item should be added to the order in the POS.</li>
 * <li><b>Reconciled</b>: The item was matched with data provided by the POS. No additional action is required for the item.</li>
 * <li><b>IsVoid</b>: The item is marked as voided and not included as part of the sale.</li>
 * </ul>
 */
export enum DataEnumerationsItemReconciledStatus {
  New = "New",
  Reconciled = "Reconciled",
  IsVoid = "IsVoid",
}

/**
 * Enumeration for the type of line-item discount.<p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum DataEnumerationsItemDiscountType {
  Percentage = "Percentage",
  Dollar = "Dollar",
}

/**
 * Store status of item<p>Possible values:</p>
 * <ul>
 * <li><b>Detected</b>: Detected</li>
 * <li><b>ManuallyAdded</b>: ManuallyAdded</li>
 * </ul>
 */
export enum DataEnumerationsItemCaptureMethod {
  Detected = "Detected",
  ManuallyAdded = "ManuallyAdded",
  Reconciliation = "Reconciliation",
}

/**
 * <p>Possible values:</p>
 * <ul>
 * <li><b>None</b>: None</li>
 * <li><b>SLS</b>: SLS</li>
 * </ul>
 */
export enum DataEnumerationsIntegrationType {
  None = "None",
  SLS = "SLS",
}

/**
 * ServiceBus Event Type<p>Possible values:</p>
 * <ul>
 * <li><b>CustomerLookup</b>: Customer lookup event for retrieving customer information by phone number</li>
 * <li><b>Checkout</b>: Checkout initiation event for Treez preview flow</li>
 * <li><b>PaymentResult</b>: Payment result event for Treez payment completion flow</li>
 * <li><b>DiscountLookup</b>: Discount code lookup event for retrieving discount information by code</li>
 * </ul>
 */
export enum DataEnumerationsEventType {
  NewOrder = "NewOrder",
  NewOrderItem = "NewOrderItem",
  UpdateOrderStatus = "UpdateOrderStatus",
  ProductImport = "ProductImport",
  CustomerLookup = "CustomerLookup",
  Checkout = "Checkout",
  PaymentResult = "PaymentResult",
  DiscountLookup = "DiscountLookup",
}

/**
 * Identifies a loyalty provider after Station-specific configuration is resolved.<p>Possible values:</p>
 * <ul>
 * <li><b>YinzCam</b>: YinzCam loyalty services.</li>
 * <li><b>Shopify</b>: Shopify customer and loyalty services.</li>
 * <li><b>Treez</b>: The implicit Treez customer lookup.</li>
 * </ul>
 */
export enum DataEnumerationsEffectiveLoyaltyProgramProvider {
  YinzCam = "YinzCam",
  Shopify = "Shopify",
  Treez = "Treez",
}

/**
 * Enumeration for the type of discount<p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum DataEnumerationsDiscountType {
  None = "None",
  Percentage = "Percentage",
  Dollar = "Dollar",
}

/**
 * Enumeration for the scope of the discount<p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum DataEnumerationsDiscountScope {
  None = "None",
  Order = "Order",
  Item = "Item",
}

/**
 * Identifies the system responsible for applying a discount code.<p>Possible values:</p>
 * <ul>
 * <li><b>Local</b>: EXO validates a code from its existing Discounts table.</li>
 * <li><b>Remote</b>: The configured POS validates and applies the code.</li>
 * </ul>
 */
export enum DataEnumerationsDiscountCodeProvider {
  Local = "Local",
  Remote = "Remote",
}

/**
 * Describes the provider-independent outcome of a customer lookup.<p>Possible values:</p>
 * <ul>
 * <li><b>Succeeded</b>: A single eligible customer was found.</li>
 * <li><b>NotFound</b>: No matching customer was found.</li>
 * <li><b>Ambiguous</b>: More than one matching customer was found.</li>
 * <li><b>NotEligible</b>: A matching customer was not eligible for the transaction.</li>
 * <li><b>ProviderUnavailable</b>: The provider could not process the lookup.</li>
 * <li><b>InvalidRequest</b>: The lookup request was invalid.</li>
 * <li><b>TimedOut</b>: The lookup did not finish within its allowed time.</li>
 * </ul>
 */
export enum DataEnumerationsCustomerLookupResultStatus {
  Succeeded = "Succeeded",
  NotFound = "NotFound",
  Ambiguous = "Ambiguous",
  NotEligible = "NotEligible",
  ProviderUnavailable = "ProviderUnavailable",
  InvalidRequest = "InvalidRequest",
  TimedOut = "TimedOut",
}

/**
 * EXO console host kind.<p>Possible values:</p>
 * <ul>
 * <li><b>Admin</b>: Admin console.</li>
 * <li><b>Checkout</b>: Checkout console.</li>
 * </ul>
 */
export enum DataEnumerationsConsoleKind {
  Admin = "Admin",
  Checkout = "Checkout",
}

/**
 * Alert Type<p>Possible values:</p>
 * <ul>
 * <li><b>Email</b>: Email</li>
 * <li><b>Sms</b>: SMS</li>
 * <li><b>PushNotificationManagementConsole</b>: Push Notification (Management Console)</li>
 * <li><b>PushNotificationClerkConsole</b>: Push Notification(Clerk Console)</li>
 * </ul>
 */
export enum DataEnumerationsAlertType {
  Email = "Email",
  Sms = "Sms",
  PushNotificationManagementConsole = "PushNotificationManagementConsole",
  PushNotificationClerkConsole = "PushNotificationClerkConsole",
}

/**
 * Alert Event Name<p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum DataEnumerationsAlertEventName {
  StationDisconnected = "StationDisconnected",
  ReaderDisconnected = "ReaderDisconnected",
  StationDisabled = "StationDisabled",
  StationInMaintenance = "StationInMaintenance",
  StationInDiagnostic = "StationInDiagnostic",
  AssistanceNeeded = "AssistanceNeeded",
  AssistanceAccepted = "AssistanceAccepted",
  TransactionVoided = "TransactionVoided",
  ConfigurationApplied = "ConfigurationApplied",
  BadTOFSensor = "BadTOFSensor",
  StationConnected = "StationConnected",
}

/**
 * Action taken for the UPC sync detail.<p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum DataDTOProductUpcDataSyncDetailActionType {
  Added = "Added",
  Updated = "Updated",
  Unchanged = "Unchanged",
  Failed = "Failed",
}

/**
 * Defines the action taken on the import record.<p>Possible values:</p>
 * <ul>
 * </ul>
 */
export enum DataDTOProductImportDetailsActionType {
  Created = "Created",
  Updated = "Updated",
  Deleted = "Deleted",
  Ignored = "Ignored",
  Failed = "Failed",
  Unchanged = "Unchanged",
  Rejected = "Rejected",
}

export interface DataDTOActivitiesList {
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * The date and time the entity was created
   * @format date-time
   */
  createdOn?: string | null;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /** StationName */
  stationName: string;
  /**
   * Status<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  status: DataEnumerationsOrderStatus;
  /**
   * ItemCount
   * @format int32
   */
  itemCount: number;
}

/** Admin Antenna DTO */
export interface DataDTOAdminAntenna {
  /**
   * Antenna Configuration ID
   * @format int32
   */
  antennaConfigurationId: number;
  /** Enabled */
  enabled: boolean;
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /**
   * PowerLevel
   * @format int32
   */
  powerLevel?: number | null;
  /** Overridden */
  overridden: boolean;
}

/** Admin Global Profile Setting View DTO */
export interface DataDTOAdminGlobalProfileSettingViewDTO {
  /** BooleanValue */
  booleanValue?: boolean | null;
  /**
   * ConfigurationSettingValueId
   * @format int32
   */
  configurationSettingValueId: number;
  /**
   * DateValue
   * @format date-time
   */
  dateValue?: string | null;
  /**
   * GlobalConfigurationSettingId
   * @format int32
   */
  globalConfigurationSettingId: number;
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /**
   * NumericValue
   * @format float
   */
  numericValue?: number | null;
  /** StringValue */
  stringValue?: string | null;
}

/** GPIO Configuration Settings View DTO */
export interface DataDTOAdminGpioConfigurationSettingsViewDTO {
  /** BooleanValue */
  booleanValue?: boolean | null;
  /**
   * DateValue
   * @format date-time
   */
  dateValue?: string | null;
  /**
   * GPIOConfigurationSettingId
   * @format int32
   */
  gpioConfigurationSettingId: number;
  /**
   * GPIOConfigurationSettingValueId
   * @format int32
   */
  gpioConfigurationSettingValueId: number;
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /**
   * NumericValue
   * @format float
   */
  numericValue?: number | null;
  /** StringValue */
  stringValue?: string | null;
}

/** Admin Reader View DTO */
export interface DataDTOAdminReaderView {
  /** AntennaConfiguration */
  antennaConfiguration: DataDTOAdminAntenna[];
  /** Enabled */
  enabled?: boolean | null;
  /**
   * Id
   * @format int32
   */
  id: number;
  /** IpAddress */
  ipAddress?: string | null;
  /**
   * MinRssi
   * @format int32
   */
  minRssi?: number | null;
  /**
   * MinStreamReadCount
   * @format int32
   */
  minStreamReadCount?: number | null;
  /**
   * Port
   * @format int32
   */
  port: number;
  /**
   * PowerLevel
   * @format int32
   */
  powerLevel?: number | null;
  /**
   * ReadCountPersistTime
   * @format int32
   */
  readCountPersistTime?: number | null;
  /**
   * ReaderConfigurationId
   * @format int32
   */
  readerConfigurationId: number;
  /** ReaderModel */
  readerModel?: string | null;
  /** ReaderName */
  readerName?: string | null;
  /** SearchMode */
  searchMode?: string | null;
  /**
   * Session
   * @format int32
   */
  session: number;
  /**
   * AntennaDwellTime
   * @format int32
   */
  antennaDwellTime?: number | null;
}

/** Admin Station Configuration View DTO */
export interface DataDTOAdminStationConfigurationView {
  /**
   * Configuration Profile ID
   * @format int32
   */
  configurationProfileId: number;
  /** Admin Global Configuration Settings */
  globalConfigurationSetting: DataDTOAdminGlobalProfileSettingViewDTO[];
  /** GPIO Configuration Settings */
  gpioConfigurationSetting: DataDTOAdminGpioConfigurationSettingsViewDTO[];
  /** Reader Configurations */
  rfidReadersConfiguration: DataDTOAdminReaderView[];
}

/** AlertDto */
export interface DataDTOAlert {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Code */
  code?: string | null;
  /** Text */
  text?: string | null;
  /** Type */
  type?: string | null;
}

/** Holds the counts based on the number of triggered alerts by day. */
export interface DataDTOAlertByDay {
  /**
   * Trigger date of the alert.
   * @format date-time
   */
  alertDate: string;
  /**
   * Total Alerts
   * @format int32
   */
  totalAlerts: number;
}

export interface DataDTOAlertHistoryList {
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * The date and time the entity was created
   * @format date-time
   */
  createdOn?: string | null;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /** Message */
  message: string;
  /** Type */
  type?: string | null;
  /**
   * StationId
   * @format int32
   */
  stationId: number;
  /** Time */
  time?: string | null;
}

/** Alert Meta Data DTO */
export interface DataDTOAlertMetadata {
  /**
   * Station Alert Type<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  type: DataEnumerationsStationAlert;
  /** Input Type */
  inputType?: string | null;
  /** Input Label */
  inputLabel?: string | null;
  /**
   * Value
   * @minLength 0
   * @maxLength 255
   */
  value?: string | null;
}

export interface DataDTOAlertNotificationCrud {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Event */
  event?: DataEnumerationsAlertEventName | null;
  /** AlertType */
  alertType: string[];
  /** Users */
  users: DataDTOUserAlertNotification[];
  /** @format int32 */
  clientId: number;
}

export interface DataDTOAlertNotificationList {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Event */
  event?: DataEnumerationsAlertEventName | null;
  /** Alert Type */
  alertType?: string | null;
  /** Receivers */
  receivers?: string | null;
  /** Enable */
  enable: boolean;
  /**
   * ClientId
   * @format int32
   */
  clientId: number;
}

export interface DataDTOAlertNotificationView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Event */
  event?: string | null;
  /** Alert Type */
  alertType: string[];
  /** Enable */
  enable: boolean;
  /** Users */
  users?: DataDTOUserAlertNotification[] | null;
}

export interface DataDTOAlertView {
  /** Input Type */
  inputType?: string | null;
  /** Input Label */
  inputLabel?: string | null;
  /** Name */
  name?: string | null;
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /** StationStatus */
  station?: DataDTOStationListing | null;
  /** Code */
  code?: string | null;
  /** Text */
  text?: string | null;
  /** CreatedAt */
  createdAt?: string | null;
  /** Type */
  type?: string | null;
}

/** Antenna CRUD DTO */
export interface DataDTOAntennaCrud {
  /** Enabled */
  enabled: boolean;
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /**
   * Power Level
   * @format int32
   */
  powerLevel?: number | null;
}

export interface DataDTOAntennaDetailsView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /** Enabled */
  enabled: boolean;
  /**
   * PowerLevel
   * @format int32
   */
  powerLevel?: number | null;
}

/** Antenna Override DTO */
export interface DataDTOAntennaOverride {
  /**
   * AntennaConfigurationId
   * @format int32
   * @min 1
   * @max 2147483647
   */
  antennaConfigurationId: number;
  /** Enabled */
  enabled: boolean;
  /** @format int32 */
  id: number;
  /** Name */
  name?: string | null;
  /**
   * PowerLevel
   * @format int32
   */
  powerLevel?: number | null;
}

/** Antenna View DTO */
export interface DataDTOAntennaView {
  /** Enabled */
  enabled: boolean;
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /**
   * PowerLevel
   * @format int32
   */
  powerLevel?: number | null;
  /**
   * ReaderConfigurationId
   * @format int32
   */
  readerConfigurationId: number;
}

/** Result of sending API key expiration notification emails. */
export interface DataDTOApiKeyExpirationNotificationResult {
  /**
   * Number of first-threshold warning emails sent.
   * @format int32
   */
  sentFirstWarningCount: number;
  /**
   * Number of second-threshold warning emails sent.
   * @format int32
   */
  sentSecondWarningCount: number;
  /**
   * Total number of emails sent.
   * @format int32
   */
  totalSentCount: number;
}

/** Information returned when creating an API key */
export interface DataDTOApiKeyView {
  /**
   * The unique identifier for the API key
   * @format int32
   */
  id: number;
  /** The name of the API key */
  name?: string | null;
  /** The actual API key token */
  token?: string | null;
  /**
   * The date and time when the API key was created, or infinity if not set
   * @format date-time
   */
  expiration?: string | null;
  /** The username of the application user who owns this API key */
  applicationUserUserName: string;
  /** The name of the application role associated with this API key */
  applicationRoleName: string;
  /** The client associated with this API key, or null for global API keys */
  clientOrganizationName?: string | null;
  /** Indicates whether the API key is active */
  active: boolean;
}

export interface DataDTOBatchUpcData {
  /** upc */
  upc: string;
  /**
   * Quantity
   * @format int32
   * @min 1
   * @max 5000
   */
  quantity: number;
  /**
   * StartingSerialNumber
   * @format int32
   */
  startingSerialNumber?: number | null;
  /** Schema */
  schema?: EncodingSchema | null;
  /**
   * Optional dictionary of options for the encoding schema.
   * At the moment, this is only needed for SGTIN-96 encodings,
   * and the only specified option is ```GS1CompanyPrefixLength```.
   */
  schemaOptions?: Record<string, string> | null;
}

export interface DataDTOBox {
  /** @format int32 */
  id: number;
  code?: string | null;
  name?: string | null;
  /** @format int32 */
  totalProducts: number;
  tunnelName?: string | null;
  inventorySession: DataDTOInventorySession;
  externalId?: string | null;
  /** @format date-time */
  createdOn: string;
  boxItems?: DataDTOBoxItem[] | null;
}

export interface DataDTOBoxItem {
  /** @format int32 */
  boxId: number;
  boxName?: string | null;
  name?: string | null;
  /** @format int32 */
  quantity: number;
  /** @format int32 */
  productId?: number | null;
  sku?: string | null;
  /** Product Description- will not mapp with db schema */
  description?: string | null;
  boxItemDetails: DataDTOBoxItemDetail[];
}

export interface DataDTOBoxItemDetail {
  /** @format int32 */
  boxItemId: number;
  decodedUpc?: string | null;
  epc?: string | null;
  notes?: string | null;
}

export interface DataDTOBoxItemListing {
  /** @format int32 */
  id: number;
  /** @format int32 */
  boxId: number;
  /** @format date-time */
  readAt: string;
  boxName: string;
  code: string;
  sku?: string | null;
  /** @format int32 */
  quantity: number;
  /** @format int32 */
  productId?: number | null;
  productName?: string | null;
  tunnelName?: string | null;
  /** @format int32 */
  tunneId: number;
  /** @format date-time */
  createdOn: string;
  /** @format date-time */
  modifiedOn: string;
}

/** Support for bulk JSON imports */
export interface DataDTOBulkImport {
  /** @format int32 */
  clientId?: number | null;
  clientName?: string | null;
  products: DataDTOProductImport[];
  /** Holds tracking information about the import process */
  tracking: DataDTOBulkImportTracking;
}

/** Holds tracking information about the import process */
export interface DataDTOBulkImportTracking {
  /** Who initiated the import process */
  source?: string | null;
  /** Identifier to track the import from the source */
  reference?: string | null;
  /**
   * The permanent ID of a ProductImport record to associate the data with
   * @format uuid
   */
  productImportPermanentId?: string | null;
}

/** Contains the employee authorization required to complete a cash payment. */
export interface DataDTOCashPaymentCompletion {
  /**
   * Gets or sets the employee PIN used to authorize the cash payment.
   * @minLength 0
   * @maxLength 100
   */
  employeePin: string;
}

/** Cash transaction report summary. */
export interface DataDTOCashTransactionSummary {
  /**
   * Total cash collected for the filtered transactions.
   * @format double
   */
  totalCashCollected: number;
  /**
   * Total purchased items for the filtered transactions.
   * @format int32
   */
  itemsPurchased: number;
}

/** Contains the sanitized discount and loyalty configuration effective for a Station. */
export interface DataDTOCheckoutConfiguration {
  /**
   * Gets or sets the Store that owns the effective configuration.
   * @format int32
   */
  storeId: number;
  /** Gets or sets the effective discount-code configuration, when available. */
  discountCode?: DataDTOCheckoutDiscountCodeConfiguration | null;
  /** Gets or sets the effective loyalty-program configuration, when available. */
  loyaltyProgram?: DataDTOCheckoutLoyaltyProgramConfiguration | null;
}

/** Contains Checkout-facing discount-code behavior and presentation settings. */
export interface DataDTOCheckoutDiscountCodeConfiguration {
  /**
   * Gets or sets when discount-code entry is available and required.<p>Possible values:</p>
   * <ul>
   * <li><b>Disabled</b>: The feature is unavailable and never blocks checkout.</li>
   * <li><b>RequiredPreOrder</b>: The lookup must succeed before the patron can begin shopping.</li>
   * <li><b>OptionalPreOrderRequiredAtCheckout</b>: The lookup is offered before shopping and becomes required before Review.</li>
   * <li><b>RequiredAtCheckout</b>: The lookup must succeed before the order can move to Review.</li>
   * <li><b>OptionalPostAttract</b>: The lookup is optionally available after the attract screen.</li>
   * </ul>
   */
  mode: DataEnumerationsLookupMode;
  /**
   * Gets or sets the applicable POS system.<p>Possible values:</p>
   * <ul>
   * <li><b>None</b>: None</li>
   * <li><b>Appetize</b>: Appetize</li>
   * <li><b>Centarro</b>: Centarro</li>
   * <li><b>RetailCloud</b>: RetailCloud</li>
   * <li><b>Square</b>: Square</li>
   * <li><b>NSPOS</b>: Netsuite</li>
   * <li><b>Demo</b>: Demo</li>
   * <li><b>RetailPro</b>: RetailPro</li>
   * <li><b>TeamworkCommerce</b>: Teamwork Commerce</li>
   * <li><b>OpSuite</b>: OpSuite</li>
   * <li><b>BestRing</b>: BestRing</li>
   * <li><b>SumUp</b>: SumUp</li>
   * <li><b>Cueto</b>: Cueto</li>
   * <li><b>Ronin</b>: Ronin</li>
   * <li><b>MCR</b>: MCR</li>
   * <li><b>AtVenu</b>: AtVenu</li>
   * <li><b>Treez</b>: Treez</li>
   * <li><b>Stripe</b>: Stripe</li>
   * </ul>
   */
  posSystem: DataEnumerationsPosSystem;
  /**
   * Gets or sets the system responsible for applying the discount code.<p>Possible values:</p>
   * <ul>
   * <li><b>Local</b>: EXO validates a code from its existing Discounts table.</li>
   * <li><b>Remote</b>: The configured POS validates and applies the code.</li>
   * </ul>
   */
  provider: DataEnumerationsDiscountCodeProvider;
  /**
   * Gets or sets the maximum number of unsuccessful attempts, or null for no configured limit.
   * @format int32
   */
  maximumAttempts?: number | null;
  /** Gets or sets the action button label. */
  buttonLabel?: string | null;
  /** Gets or sets the action button color. */
  buttonColor?: string | null;
  /** Gets or sets the message displayed after success. */
  successMessage?: string | null;
  /** Gets or sets the message displayed after failure. */
  failureMessage?: string | null;
}

/** Contains Checkout-facing loyalty lookup behavior and presentation settings. */
export interface DataDTOCheckoutLoyaltyProgramConfiguration {
  /**
   * Gets or sets when loyalty lookup is available and required.<p>Possible values:</p>
   * <ul>
   * <li><b>Disabled</b>: The feature is unavailable and never blocks checkout.</li>
   * <li><b>RequiredPreOrder</b>: The lookup must succeed before the patron can begin shopping.</li>
   * <li><b>OptionalPreOrderRequiredAtCheckout</b>: The lookup is offered before shopping and becomes required before Review.</li>
   * <li><b>RequiredAtCheckout</b>: The lookup must succeed before the order can move to Review.</li>
   * <li><b>OptionalPostAttract</b>: The lookup is optionally available after the attract screen.</li>
   * </ul>
   */
  mode: DataEnumerationsLookupMode;
  /**
   * Gets or sets the applicable POS system.<p>Possible values:</p>
   * <ul>
   * <li><b>None</b>: None</li>
   * <li><b>Appetize</b>: Appetize</li>
   * <li><b>Centarro</b>: Centarro</li>
   * <li><b>RetailCloud</b>: RetailCloud</li>
   * <li><b>Square</b>: Square</li>
   * <li><b>NSPOS</b>: Netsuite</li>
   * <li><b>Demo</b>: Demo</li>
   * <li><b>RetailPro</b>: RetailPro</li>
   * <li><b>TeamworkCommerce</b>: Teamwork Commerce</li>
   * <li><b>OpSuite</b>: OpSuite</li>
   * <li><b>BestRing</b>: BestRing</li>
   * <li><b>SumUp</b>: SumUp</li>
   * <li><b>Cueto</b>: Cueto</li>
   * <li><b>Ronin</b>: Ronin</li>
   * <li><b>MCR</b>: MCR</li>
   * <li><b>AtVenu</b>: AtVenu</li>
   * <li><b>Treez</b>: Treez</li>
   * <li><b>Stripe</b>: Stripe</li>
   * </ul>
   */
  posSystem: DataEnumerationsPosSystem;
  /**
   * Gets or sets the effective loyalty provider, including implicit Treez.<p>Possible values:</p>
   * <ul>
   * <li><b>YinzCam</b>: YinzCam loyalty services.</li>
   * <li><b>Shopify</b>: Shopify customer and loyalty services.</li>
   * <li><b>Treez</b>: The implicit Treez customer lookup.</li>
   * </ul>
   */
  provider: DataEnumerationsEffectiveLoyaltyProgramProvider;
  /**
   * Gets or sets the value Checkout must collect.<p>Possible values:</p>
   * <ul>
   * <li><b>Phone</b>: A customer phone number.</li>
   * <li><b>Email</b>: A customer email address.</li>
   * <li><b>DiscountCode</b>: A customer discount code</li>
   * </ul>
   */
  inputType: DataEnumerationsLookupInputType;
  /**
   * Gets or sets the maximum number of unsuccessful attempts, or null for no configured limit.
   * @format int32
   */
  maximumAttempts?: number | null;
  /** Gets or sets the action button label. */
  buttonLabel?: string | null;
  /** Gets or sets the action button color. */
  buttonColor?: string | null;
  /** Gets or sets the message displayed after success. */
  successMessage?: string | null;
  /** Gets or sets the message displayed after failure. */
  failureMessage?: string | null;
}

export interface DataDTOClientCrud {
  /** OrganizationName */
  organizationName?: string | null;
  /** Logo */
  logo?: string | null;
  /** FirstName */
  firstName?: string | null;
  /** LastName */
  lastName?: string | null;
  /** ClientPosition */
  position?: string | null;
  /** Email */
  email?: string | null;
  /** PhoneNo */
  phoneNo?: string | null;
  /** AlternativePhoneNo */
  altPhoneNo?: string | null;
  /** AddressDetails */
  addressDetails?: string | null;
  /** Notes */
  notes?: string | null;
  /** IsActive */
  isActive?: boolean | null;
  /** SendItemsWithInactiveProductsToPos */
  sendItemsWithInactiveProductsToPos: boolean;
  /** SendItemsWithInvalidProductsToPos */
  sendItemsWithInvalidProductsToPos: boolean;
}

export interface DataDTOClientId {
  /**
   * ClientId
   * @format int32
   */
  clientId: number;
}

/** ClientIntegrationDto */
export interface DataDTOClientIntegration {
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * ClientId
   * @format int32
   */
  clientId: number;
  /** IsActive */
  isActive: boolean;
  accessKey?: string | null;
  /** @format date-time */
  tokenExpiryDate?: string | null;
  notes?: string | null;
  configData?: string | null;
  topicQueueName?: string | null;
  queueRequestMessage?: string | null;
  /** @format date-time */
  importStartTime?: string | null;
}

/** ClientIntegrationDto */
export interface DataDTOClientIntegrationCrud {
  /**
   * ClientId
   * @format int32
   */
  clientId: number;
  /** IsActive */
  isActive: boolean;
  accessKey?: string | null;
  /** @format date-time */
  tokenExpiryDate?: string | null;
  notes?: string | null;
  configData?: string | null;
  topicQueueName?: string | null;
  queueRequestMessage?: string | null;
  /** @format date-time */
  importStartTime?: string | null;
}

/** ClientIntegrationListingDto */
export interface DataDTOClientIntegrationListing {
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * ClientId
   * @format int32
   */
  clientId: number;
  /** IsActive */
  isActive: boolean;
  accessKey?: string | null;
  /** @format date-time */
  tokenExpiryDate?: string | null;
  notes?: string | null;
  configData?: string | null;
  topicQueueName?: string | null;
  queueRequestMessage?: string | null;
  /** @format date-time */
  importStartTime?: string | null;
  /**
   * Created At
   * @format date-time
   */
  createdOn?: string | null;
}

/** ClientIntegrationUpdateDto */
export interface DataDTOClientIntegrationUpdate {
  /** IsActive */
  isActive: boolean;
  accessKey?: string | null;
  /** @format date-time */
  tokenExpiryDate?: string | null;
  notes?: string | null;
  configData?: string | null;
  topicQueueName?: string | null;
  queueRequestMessage?: string | null;
  /** @format date-time */
  importStartTime?: string | null;
}

export interface DataDTOClientListing {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** OrganizationName */
  organizationName?: string | null;
  /** Logo */
  logo?: string | null;
  /** First Name */
  firstName?: string | null;
  /** LastName */
  lastName?: string | null;
  /** ClientPosition */
  position?: string | null;
  /** Email */
  email?: string | null;
  /** PhoneNo */
  phoneNo?: string | null;
  /** AlternativePhoneNo */
  altPhoneNo?: string | null;
  /** AddressDetails */
  addressDetails?: string | null;
  /** Notes */
  notes?: string | null;
  /** IsActive */
  isActive: boolean;
  /**
   * Created At
   * @format date-time
   */
  createdOn?: string | null;
}

/** Editable client-scoped SSO provider configuration. */
export interface DataDTOClientSsoProviderCrud {
  /**
   * EXO client identifier assigned from the route.
   * @format int32
   */
  clientId: number;
  /**
   * Provider kind, such as Entra or Authentik.<p>Possible values:</p>
   * <ul>
   * <li><b>Entra</b>: Microsoft Entra.</li>
   * <li><b>Authentik</b>: Authentik.</li>
   * </ul>
   */
  providerKind: SsoClientSsoProviderKind;
  /** Provider display name. */
  displayName: string;
  /** Login button label. */
  buttonLabel: string;
  /** Optional button background color. */
  displayBackground?: string | null;
  /** Optional button text color. */
  displayColor?: string | null;
  /** Determines whether this provider can be used for SSO. */
  isEnabled: boolean;
  /** OIDC authority. */
  authority: string;
  /** OIDC client identifier. */
  clientIdValue: string;
  /** Optional plaintext OIDC client secret to encrypt and store. */
  clientSecret?: string | null;
  /** Determines whether the stored OIDC client secret should be cleared during update. */
  clearClientSecret: boolean;
  /** OIDC redirect URI. */
  redirectUri: string;
  /** OIDC scopes. */
  scopes: string;
  /** Optional OIDC prompt value. */
  prompt?: string | null;
  /** Determines whether PKCE is used. */
  usePkce: boolean;
  /** Determines whether claims are fetched from UserInfo. */
  getClaimsFromUserInfoEndpoint: boolean;
  /** External access-gate claim type. */
  accessClaimType: string;
  /** External access-gate claim value. */
  accessClaimValue: string;
}

/** Management view of a client-scoped SSO provider configuration. */
export interface DataDTOClientSsoProviderView {
  /**
   * Stable SSO provider identifier.
   * @format int32
   */
  id: number;
  /**
   * EXO client identifier that owns the SSO provider.
   * @format int32
   */
  clientId: number;
  /**
   * Provider kind, such as Entra or Authentik.<p>Possible values:</p>
   * <ul>
   * <li><b>Entra</b>: Microsoft Entra.</li>
   * <li><b>Authentik</b>: Authentik.</li>
   * </ul>
   */
  providerKind: SsoClientSsoProviderKind;
  /** Provider display name. */
  displayName: string;
  /** Login button label. */
  buttonLabel: string;
  /** Optional button background color. */
  displayBackground?: string | null;
  /** Optional button text color. */
  displayColor?: string | null;
  /** Determines whether this provider can be used for SSO. */
  isEnabled: boolean;
  /** OIDC authority. */
  authority: string;
  /** OIDC client identifier. */
  clientIdValue: string;
  /** Determines whether a client secret is configured. */
  hasClientSecret: boolean;
  /**
   * Date and time when the encrypted client secret was last updated.
   * @format date-time
   */
  clientSecretUpdatedOn?: string | null;
  /** OIDC redirect URI. */
  redirectUri: string;
  /** OIDC scopes. */
  scopes: string;
  /** Optional OIDC prompt value. */
  prompt?: string | null;
  /** Determines whether PKCE is used. */
  usePkce: boolean;
  /** Determines whether claims are fetched from UserInfo. */
  getClaimsFromUserInfoEndpoint: boolean;
  /** External access-gate claim type. */
  accessClaimType: string;
  /** External access-gate claim value. */
  accessClaimValue: string;
}

/** Client User Mapping */
export interface DataDTOClientUserList {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
}

/** ClientViewDto */
export interface DataDTOClientView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** OrganizationName */
  organizationName?: string | null;
  /** Logo */
  logo?: string | null;
  /** FirstName */
  firstName?: string | null;
  /** LastName */
  lastName?: string | null;
  /** ClientPosition */
  position?: string | null;
  /** Email */
  email?: string | null;
  /** PhoneNo */
  phoneNo?: string | null;
  /** AlternativePhoneNo */
  altPhoneNo?: string | null;
  /** AddressDetails */
  addressDetails?: string | null;
  /** Notes */
  notes?: string | null;
  /** IsActive */
  isActive: boolean;
  /** SendItemsWithInactiveProductsToPos */
  sendItemsWithInactiveProductsToPos: boolean;
  /** SendItemsWithInvalidProductsToPos */
  sendItemsWithInvalidProductsToPos: boolean;
}

export interface DataDTOCommissionRfidTags {
  /**
   * StartingSerialNumber
   * @format int32
   */
  startingSerialNumber?: number | null;
  /** Schema */
  schema?: EncodingSchema | null;
  /**
   * Optional dictionary of options for the encoding schema.
   * At the moment, this is only needed for SGTIN-96 encodings,
   * and the only specified option is ```GS1CompanyPrefixLength```.
   */
  schemaOptions?: Record<string, string> | null;
  /**
   * Quantity
   * @format int32
   * @min 1
   * @max 5000
   */
  quantity: number;
  /**
   * Notes
   * @minLength 0
   * @maxLength 1000
   */
  notes?: string | null;
}

export interface DataDTOCommissionRfidTagsBatch {
  /** Notes */
  notes?: string | null;
  /** Upc */
  upcs: DataDTOBatchUpcData[];
}

export interface DataDTOCommissionedEpcs {
  /** The UPC for which the EPC data was commissioned */
  upc: string;
  /** The commissioned EPC data for the UPC */
  epcs: string[];
}

/** Request used to exchange a one-time SSO login code for EXO login state. */
export interface DataDTOCompleteSsoRequest {
  /** Short-lived one-time login code issued by the SSO callback endpoint. */
  loginCode: string;
}

export interface DataDTOConfigProfileListing {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /**
   * InstallCount
   * @format int32
   */
  installCount: number;
  /**
   * CreatedOn
   * @format date-time
   */
  createdOn?: string | null;
  /** isAllClients */
  isAllClient: boolean;
  /** ReaderModel */
  readerModel: string[];
  /** Station */
  stations: string[];
}

export interface DataDTOConfigureProfileClient {
  /**
   * Id
   * @format int32
   */
  id?: number | null;
  /** Name */
  name?: string | null;
}

/** Request DTO for creating an API Key */
export interface DataDTOCreateApiKeyRequest {
  /**
   * When the API Key should expire, or null if it should not expire
   * @format date-time
   */
  expiration?: string | null;
  /** The name of the API Key */
  name: string;
}

export interface DataDTOCreditCardData {
  /** CreditType */
  creditType?: string | null;
  /** CreditLastFour */
  creditLastFour?: string | null;
  /** CreditAuthorization */
  creditAuthorization?: string | null;
}

/** CurrentOrderExternalIdDto */
export interface DataDTOCurrentOrderExternalId {
  /**
   * StationPermanentId
   * @format uuid
   */
  stationPermanentId: string;
  /** OrderExternalId */
  orderExternalId: string;
}

/** Contains transient customer lookup data supplied with an order Review transition. */
export interface DataDTOCustomerLookupAssociation {
  /**
   * Gets or sets the completed lookup's correlation identifier.
   * @format uuid
   */
  lookupRequestId: string;
  /**
   * Gets or sets the effective provider that returned the customer.<p>Possible values:</p>
   * <ul>
   * <li><b>YinzCam</b>: YinzCam loyalty services.</li>
   * <li><b>Shopify</b>: Shopify customer and loyalty services.</li>
   * <li><b>Treez</b>: The implicit Treez customer lookup.</li>
   * </ul>
   */
  provider: DataEnumerationsEffectiveLoyaltyProgramProvider;
  /**
   * Gets or sets the provider's customer identifier.
   * @minLength 0
   * @maxLength 450
   */
  externalCustomerId: string;
  /**
   * Gets or sets the lookup identifier needed transiently by the POS integration.
   * @minLength 0
   * @maxLength 50
   */
  identifier?: string | null;
  /**
   * Gets or sets a display name needed transiently by the POS integration.
   * @minLength 0
   * @maxLength 300
   */
  displayName?: string | null;
}

/** Data transfer object for customer lookup responses. */
export interface DataDTOCustomerLookupResponse {
  /**
   * Gets or sets the correlation identifier from the original lookup request.
   * @format uuid
   */
  lookupRequestId: string;
  /**
   * Gets or sets the permanent identifier for the station that initiated the lookup.
   * @format uuid
   */
  stationPermanentId: string;
  /** Gets or sets the unique identifier for the customer in the Treez system. */
  customerId?: string | null;
  /** Gets or sets the customer's first name. */
  firstName?: string | null;
  /** Gets or sets the customer's last name. */
  lastName?: string | null;
  /** Gets or sets the customer's phone number. */
  phone?: string | null;
  /** Gets or sets the customer's email address. */
  email?: string | null;
  /** Gets or sets the patient type classification (e.g., ADULT, MEDICAL). */
  patientType?: string | null;
  /** Gets or sets a value indicating whether the customer was found in the Treez system. */
  found: boolean;
  /** Gets or sets the provider-independent outcome of the lookup. */
  status?: DataEnumerationsCustomerLookupResultStatus | null;
  /** Gets or sets an error message if the lookup operation failed. */
  errorMessage?: string | null;
}

/** Request to delete a bounded collection of Shopify sessions. */
export interface DataDTODeleteShopifySessions {
  /**
   * Shopify session identifiers to delete.
   * @maxItems 100
   */
  sessionIds: string[];
}

/** Contains transient discount-code data supplied with an order Review transition. */
export interface DataDTODiscountCodeAssociation {
  /**
   * Gets or sets the configured discount-code provider.<p>Possible values:</p>
   * <ul>
   * <li><b>Local</b>: EXO validates a code from its existing Discounts table.</li>
   * <li><b>Remote</b>: The configured POS validates and applies the code.</li>
   * </ul>
   */
  provider: DataEnumerationsDiscountCodeProvider;
  /**
   * Gets or sets the code supplied by the patron.
   * @minLength 0
   * @maxLength 255
   */
  code: string;
}

/** DiscountCrud DTO */
export interface DataDTODiscountCrud {
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  code: string;
  /**
   * @minLength 0
   * @maxLength 450
   */
  externalId?: string | null;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string | null;
  /**
   * The type of discount<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  discountType: DataEnumerationsDiscountType;
  /**
   * The amount of the discount
   * @format double
   */
  amount: number;
  /**
   * The scope of the discount<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  discountScope: DataEnumerationsDiscountScope;
  /** Whether the discount is active */
  isActive: boolean;
  /**
   * The date and time the discount is active from
   * @format date-time
   */
  activeFrom?: string | null;
  /**
   * The date and time the discount is active to
   * @format date-time
   */
  activeTo?: string | null;
  /**
   * The client id
   * @format int32
   */
  clientId: number;
}

export interface DataDTODiscountListing {
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * Modified On
   * @format date-time
   */
  modifiedOn?: string | null;
  /**
   * Created On
   * @format date-time
   */
  createdOn?: string | null;
  /** Modified By */
  modifiedBy?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  code: string;
  /**
   * @minLength 0
   * @maxLength 450
   */
  externalId?: string | null;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string | null;
  /**
   * The type of discount<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  discountType: DataEnumerationsDiscountType;
  /**
   * The amount of the discount
   * @format double
   */
  amount: number;
  /**
   * The scope of the discount<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  discountScope: DataEnumerationsDiscountScope;
  /** Whether the discount is active */
  isActive: boolean;
  /**
   * The date and time the discount is active from
   * @format date-time
   */
  activeFrom?: string | null;
  /**
   * The date and time the discount is active to
   * @format date-time
   */
  activeTo?: string | null;
  /**
   * The client id
   * @format int32
   */
  clientId: number;
  /** The client */
  client?: DataDTOClientView | null;
}

export interface DataDTODiscountView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * Modified On
   * @format date-time
   */
  modifiedOn?: string | null;
  /**
   * Created On
   * @format date-time
   */
  createdOn?: string | null;
  /** Modified By */
  modifiedBy?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 255
   */
  code: string;
  /**
   * @minLength 0
   * @maxLength 450
   */
  externalId?: string | null;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string | null;
  /**
   * The type of discount<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  discountType: DataEnumerationsDiscountType;
  /**
   * The amount of the discount
   * @format double
   */
  amount: number;
  /**
   * The scope of the discount<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  discountScope: DataEnumerationsDiscountScope;
  /** Whether the discount is active */
  isActive: boolean;
  /**
   * The date and time the discount is active from
   * @format date-time
   */
  activeFrom?: string | null;
  /**
   * The date and time the discount is active to
   * @format date-time
   */
  activeTo?: string | null;
  /**
   * The client id
   * @format int32
   */
  clientId: number;
}

/** Contains the data needed to finalize an external POS payment in a single call. */
export interface DataDTOExternalPaymentCompletion {
  /** Optional order status to apply when finalizing the payment. Defaults to Paid when not provided. */
  orderStatus?: DataEnumerationsOrderStatus | null;
  /**
   * Discount total amount for the order.
   * @format double
   */
  discountTotalAmount?: number | null;
  /**
   * Order-level discount amount for the order.
   * @format double
   */
  orderDiscountAmount?: number | null;
  /**
   * Tax amount for the order.
   * @format double
   */
  taxAmount?: number | null;
  /**
   * This will contain Fee amount if it exists.
   * @format double
   */
  fee1?: number | null;
  /**
   * This will contain another Fee amount if it exists.
   * @format double
   */
  fee2?: number | null;
  /**
   * This will contain yet another Fee amount if it exists.
   * @format double
   */
  fee3?: number | null;
  /**
   * The order base amount - equivalent to the sum of items at full price.
   * No taxes, fees, or discounts are taken into account.
   * @format double
   */
  baseAmount?: number | null;
  /**
   * The subtotal amount before tax
   * @format double
   */
  subTotalAmount?: number | null;
  /**
   * The grand total amount after tax, fees, and discounts.
   * @format double
   */
  grandTotalAmount?: number | null;
  /**
   * The total of all fees.
   * @format double
   */
  feeTotalAmount?: number | null;
  /** External Payment Transaction Id. */
  externalPaymentTransactionId?: string | null;
  /** Receipt Id supplied by the POS. */
  receiptId?: string | null;
  /** Credit type for the external payment. */
  creditType?: string | null;
  /** Credit Last Four. */
  creditLastFour?: string | null;
  /** Credit Authorization code. */
  creditAuthorization?: string | null;
}

export interface DataDTOExternalPaymentData {
  /** ExternalPaymentTransactionId */
  externalPaymentTransactionId?: string | null;
  /** ReceiptId */
  receiptId?: string | null;
  /** CreditType */
  creditType?: string | null;
  /** CreditLastFour */
  creditLastFour?: string | null;
  /** CreditAuthorization */
  creditAuthorization?: string | null;
}

export interface DataDTOExternalPaymentTransactionId {
  /** External Payment Transaction Id */
  externalPaymentTransactionId?: string | null;
}

/** Request to generate a single EPC */
export interface DataDTOGenerateEpcRequest {
  /**
   * UPC to encode into the EPC
   * @minLength 1
   */
  upc: string;
  /**
   * Encoding schema to use for EPC generation<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  schema: EncodingSchema;
  /**
   * Serial number to encode into the EPC
   * @format int64
   */
  serialNumber: number;
  /**
   * Optional dictionary of options for the encoding schema.
   * At the moment, this is only needed for SGTIN-96 encodings,
   * and the only specified option is ```GS1CompanyPrefixLength```.
   */
  schemaOptions?: Record<string, string> | null;
}

/** Response containing a generated EPC */
export interface DataDTOGenerateEpcResponse {
  /** The generated EPC value */
  epc: string;
  /** The UPC that was encoded */
  upc: string;
  /**
   * The schema used for encoding<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  schema: EncodingSchema;
  /**
   * The serial number that was encoded
   * @format int64
   */
  serialNumber: number;
}

/** Global Profile CRUD DTO */
export interface DataDTOGlobalProfileCrud {
  /** Clients */
  clients: number[];
  /**
   * Description
   * @minLength 0
   * @maxLength 4000
   */
  description?: string | null;
  /** GlobalConfigSetting */
  globalConfigSettingValue: DataDTOGlobalProfileSettingValueCrud[];
  /** GPIOConfigSetting */
  gpioConfigSettingValue: DataDTOGpioConfigurationSettingValueCrud[];
  /** IsAllClient */
  isAllClient: boolean;
  /**
   * Name
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /** RemovedClients */
  removedClients: number[];
  /** RemovedRfidReaders */
  removedRfidReaders: number[];
  /** ReaderConfiguartion */
  rfidReader: DataDTORfidReaderCrud[];
}

/** Global Profile Setting Value CRUD DTO */
export interface DataDTOGlobalProfileSettingValueCrud {
  /** BooleanValue */
  booleanValue?: boolean | null;
  /**
   * DateValue
   * @format date-time
   */
  dateValue?: string | null;
  /**
   * GlobalConfigurationSettingId
   * @format int32
   */
  globalConfigurationSettingId: number;
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * NumericValue
   * @format float
   */
  numericValue?: number | null;
  /** StringValue */
  stringValue?: string | null;
}

/** Global Profile Setting Value Override DTO */
export interface DataDTOGlobalProfileSettingValueOverride {
  /** BooleanValue */
  booleanValue?: boolean | null;
  /**
   * ConfigurationSettingValueId
   * @format int32
   * @min 1
   * @max 2147483647
   */
  configurationSettingValueId: number;
  /**
   * DateValue
   * @format date-time
   */
  dateValue?: string | null;
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * NumericValue
   * @format float
   */
  numericValue?: number | null;
  /** StringValue */
  stringValue?: string | null;
}

/** Global Profile Setting View DTO */
export interface DataDTOGlobalProfileSettingValueView {
  /** BooleanValue */
  booleanValue?: boolean | null;
  /**
   * ConfigurationProfileId
   * @format int32
   */
  configurationProfileId: number;
  /**
   * DateValue
   * @format date-time
   */
  dateValue?: string | null;
  /**
   * GlobalConfigurationSettingId
   * @format int32
   */
  globalConfigurationSettingId: number;
  /**
   * Id
   * @format int32
   */
  id: number;
  /** MachineName */
  machineName?: string | null;
  /** Name */
  name?: string | null;
  /**
   * NumericValue
   * @format float
   */
  numericValue?: number | null;
  /** StringValue */
  stringValue?: string | null;
}

/** Global Profile Setting View DTO */
export interface DataDTOGlobalProfileSettingView {
  /** DataType */
  dataType?: string | null;
  /** DefaultValue */
  defaultValue?: string | null;
  /** HelpText */
  helpText?: string | null;
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /** Validations */
  validations?: string | null;
}

/** Global Profile View DTO */
export interface DataDTOGlobalProfileView {
  /**
   * Global Profile ID
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /** AllCLients */
  allClients: boolean;
  /** Description */
  description?: string | null;
  /** GpioConfigurationSetting */
  clients: DataDTOConfigureProfileClient[];
  /** Id */
  globalConfigurationSetting: DataDTOGlobalProfileSettingValueView[];
  /** Name */
  gpioConfigurationSetting: DataDTOGpioConfigurationSettingValueView[];
  /** RfidReaderConfiguration */
  rfidReadersConfiguration: DataDTOReaderView[];
}

/** GPIO Configuration Setting Value CRUD DTO */
export interface DataDTOGpioConfigurationSettingValueCrud {
  /** BooleanValue */
  booleanValue?: boolean | null;
  /**
   * DateValue
   * @format date-time
   */
  dateValue?: string | null;
  /**
   * GPIOConfigurationSettingId
   * @format int32
   */
  gpioConfigurationSettingId: number;
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * NumericValue
   * @format float
   */
  numericValue?: number | null;
  /** StringValue */
  stringValue?: string | null;
}

/** GPIO Configuration Setting Value Override DTO */
export interface DataDTOGpioConfigurationSettingValueOverride {
  /** BooleanValue */
  booleanValue?: boolean | null;
  /**
   * DateValue
   * @format date-time
   */
  dateValue?: string | null;
  /**
   * ConfigurationSettingValueId
   * @format int32
   * @min 1
   * @max 2147483647
   */
  gpioConfigurationSettingValueId: number;
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * NumericValue
   * @format float
   */
  numericValue?: number | null;
  /** StringValue */
  stringValue?: string | null;
}

/** GPIO Configuration Setting View DTO */
export interface DataDTOGpioConfigurationSettingValueView {
  /** BooleanValue */
  booleanValue?: boolean | null;
  /**
   * ConfigurationProfileId
   * @format int32
   */
  configurationProfileId: number;
  /**
   * DateValue
   * @format date-time
   */
  dateValue?: string | null;
  /**
   * GPIOConfigurationSettingId
   * @format int32
   */
  gpioConfigurationSettingId: number;
  /**
   * Id
   * @format int32
   */
  id: number;
  /** MachineName */
  machineName?: string | null;
  /** Name */
  name?: string | null;
  /**
   * NumericValue
   * @format float
   */
  numericValue?: number | null;
  /** StringValue */
  stringValue?: string | null;
}

export interface DataDTOGpioConfigurationSettingView {
  /** DataType */
  dataType?: string | null;
  /** DefaultValue */
  defaultValue?: string | null;
  /** HelpText */
  helpText?: string | null;
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
}

export interface DataDTOHealth {
  /**
   * Cpu
   * @format double
   */
  cpu?: number | null;
  /**
   * Memory
   * @format double
   */
  memory?: number | null;
  /**
   * SystemCpu
   * @format double
   */
  systemCpu?: number | null;
  /**
   * AvailableMemory
   * @format double
   */
  availableMemory?: number | null;
  /**
   * TotalMemory
   * @format double
   */
  totalMemory?: number | null;
  /**
   * ThreadCount
   * @format int32
   */
  threadCount: number;
  /** Status */
  status?: string | null;
  /** BroadcastMessage */
  broadcastMessage?: string | null;
  /**
   * Station's machine name
   * @maxLength 200
   */
  machineName?: string | null;
  /** RfidReaders */
  rfidReaderHealthDto: DataDTORfidReaderHealth[];
}

export interface DataDTOHealthStaticsGraph {
  /** Data */
  data: number[];
  /** Labels */
  labels: string[];
}

export interface DataDTOHealthStatisticsListing {
  /** Id */
  id?: string | null;
  /**
   * Cpu
   * @format double
   */
  cpu?: number | null;
  /**
   * Memory
   * @format double
   */
  memory?: number | null;
  /**
   * SystemCpu
   * @format double
   */
  systemCpu?: number | null;
  /**
   * AvailableMemory
   * @format double
   */
  availableMemory?: number | null;
  /**
   * CreatedOn
   * @format date-time
   */
  createdOn?: string | null;
  /** StationName */
  stationName?: string | null;
  /**
   * StationId
   * @format int32
   */
  stationId?: number | null;
  /** Status */
  status?: string | null;
  /** BroadCastMessage */
  broadCastMessage?: string | null;
  /**
   * TotalMemory
   * @format double
   */
  totalMemory?: number | null;
}

export interface DataDTOIntelligencePointCrud {
  /**
   * Name
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * Store ID
   * @format int32
   */
  storeId: number;
}

export interface DataDTOIntelligencePointList {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /**
   * Store ID
   * @format int32
   */
  storeId: number;
  /** Store Name */
  storeName?: string | null;
  /** Created by */
  createdBy?: string | null;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /**
   * CreatedOn
   * @format date-time
   */
  createdOn?: string | null;
}

export interface DataDTOIntelligencePointView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /**
   * Store ID
   * @format int32
   */
  storeId: number;
  /** Store Name */
  storeName?: string | null;
  /**
   * The time the entity was created.
   * @format date-time
   */
  createdOn?: string | null;
}

/** Contains integration-only Store discount-code configuration. */
export interface DataDTOInternalDiscountCodeConfiguration {
  /**
   * Gets or sets the configured lookup mode.<p>Possible values:</p>
   * <ul>
   * <li><b>Disabled</b>: The feature is unavailable and never blocks checkout.</li>
   * <li><b>RequiredPreOrder</b>: The lookup must succeed before the patron can begin shopping.</li>
   * <li><b>OptionalPreOrderRequiredAtCheckout</b>: The lookup is offered before shopping and becomes required before Review.</li>
   * <li><b>RequiredAtCheckout</b>: The lookup must succeed before the order can move to Review.</li>
   * <li><b>OptionalPostAttract</b>: The lookup is optionally available after the attract screen.</li>
   * </ul>
   */
  mode: DataEnumerationsLookupMode;
  /**
   * Gets or sets the applicable POS system.<p>Possible values:</p>
   * <ul>
   * <li><b>None</b>: None</li>
   * <li><b>Appetize</b>: Appetize</li>
   * <li><b>Centarro</b>: Centarro</li>
   * <li><b>RetailCloud</b>: RetailCloud</li>
   * <li><b>Square</b>: Square</li>
   * <li><b>NSPOS</b>: Netsuite</li>
   * <li><b>Demo</b>: Demo</li>
   * <li><b>RetailPro</b>: RetailPro</li>
   * <li><b>TeamworkCommerce</b>: Teamwork Commerce</li>
   * <li><b>OpSuite</b>: OpSuite</li>
   * <li><b>BestRing</b>: BestRing</li>
   * <li><b>SumUp</b>: SumUp</li>
   * <li><b>Cueto</b>: Cueto</li>
   * <li><b>Ronin</b>: Ronin</li>
   * <li><b>MCR</b>: MCR</li>
   * <li><b>AtVenu</b>: AtVenu</li>
   * <li><b>Treez</b>: Treez</li>
   * <li><b>Stripe</b>: Stripe</li>
   * </ul>
   */
  posSystem: DataEnumerationsPosSystem;
  /**
   * Gets or sets the discount-code provider.<p>Possible values:</p>
   * <ul>
   * <li><b>Local</b>: EXO validates a code from its existing Discounts table.</li>
   * <li><b>Remote</b>: The configured POS validates and applies the code.</li>
   * </ul>
   */
  provider: DataEnumerationsDiscountCodeProvider;
  /**
   * Gets or sets the beginning of the active window.
   * @format date-time
   */
  activeFrom?: string | null;
  /**
   * Gets or sets the end of the active window.
   * @format date-time
   */
  activeTo?: string | null;
}

/** Contains integration-only Store discount and loyalty configuration. */
export interface DataDTOInternalDiscountLoyaltyConfiguration {
  /**
   * Gets or sets the Store identifier.
   * @format int32
   */
  storeId: number;
  /** Gets or sets the configured discount-code integration, when enabled. */
  discountCode?: DataDTOInternalDiscountCodeConfiguration | null;
  /** Gets or sets the configured loyalty integration, when enabled. */
  loyaltyProgram?: DataDTOInternalLoyaltyProgramConfiguration | null;
}

/** Contains decrypted integration-only Store loyalty configuration. */
export interface DataDTOInternalLoyaltyProgramConfiguration {
  /**
   * Gets or sets the configured lookup mode.<p>Possible values:</p>
   * <ul>
   * <li><b>Disabled</b>: The feature is unavailable and never blocks checkout.</li>
   * <li><b>RequiredPreOrder</b>: The lookup must succeed before the patron can begin shopping.</li>
   * <li><b>OptionalPreOrderRequiredAtCheckout</b>: The lookup is offered before shopping and becomes required before Review.</li>
   * <li><b>RequiredAtCheckout</b>: The lookup must succeed before the order can move to Review.</li>
   * <li><b>OptionalPostAttract</b>: The lookup is optionally available after the attract screen.</li>
   * </ul>
   */
  mode: DataEnumerationsLookupMode;
  /**
   * Gets or sets the applicable POS system.<p>Possible values:</p>
   * <ul>
   * <li><b>None</b>: None</li>
   * <li><b>Appetize</b>: Appetize</li>
   * <li><b>Centarro</b>: Centarro</li>
   * <li><b>RetailCloud</b>: RetailCloud</li>
   * <li><b>Square</b>: Square</li>
   * <li><b>NSPOS</b>: Netsuite</li>
   * <li><b>Demo</b>: Demo</li>
   * <li><b>RetailPro</b>: RetailPro</li>
   * <li><b>TeamworkCommerce</b>: Teamwork Commerce</li>
   * <li><b>OpSuite</b>: OpSuite</li>
   * <li><b>BestRing</b>: BestRing</li>
   * <li><b>SumUp</b>: SumUp</li>
   * <li><b>Cueto</b>: Cueto</li>
   * <li><b>Ronin</b>: Ronin</li>
   * <li><b>MCR</b>: MCR</li>
   * <li><b>AtVenu</b>: AtVenu</li>
   * <li><b>Treez</b>: Treez</li>
   * <li><b>Stripe</b>: Stripe</li>
   * </ul>
   */
  posSystem: DataEnumerationsPosSystem;
  /**
   * Gets or sets the explicitly configured loyalty provider.<p>Possible values:</p>
   * <ul>
   * <li><b>YinzCam</b>: YinzCam loyalty services.</li>
   * <li><b>Shopify</b>: Shopify customer and loyalty services.</li>
   * </ul>
   */
  provider: DataEnumerationsLoyaltyProgramProvider;
  /** Gets or sets the provider API hostname. */
  hostname?: string | null;
  /** Gets or sets the decrypted provider username. */
  username?: string | null;
  /** Gets or sets the decrypted provider password. */
  password?: string | null;
  /**
   * Gets or sets the beginning of the active window.
   * @format date-time
   */
  activeFrom?: string | null;
  /**
   * Gets or sets the end of the active window.
   * @format date-time
   */
  activeTo?: string | null;
}

export interface DataDTOInventoryBoxImport {
  isa?: string | null;
  parentId?: string | null;
  childEpcs?: string[] | null;
  action?: string | null;
  bizStep?: string | null;
  disposition?: string | null;
  readPoint?: string | null;
  tunnelCode?: string | null;
  /** @format date-time */
  eventTime: string;
}

export interface DataDTOInventoryImport {
  /** @format int32 */
  clientId: number;
  inventoryBoxes: DataDTOInventoryBoxImport[];
}

export interface DataDTOInventorySession {
  /** @format int32 */
  id: number;
  /** @format int32 */
  tunnelId: number;
  /** @format date-time */
  startedAt: string;
  /** @format date-time */
  completedAt?: string | null;
  notes?: string | null;
  /** @format int32 */
  clientId: number;
  /** @format int32 */
  userId: number;
}

export interface DataDTOInventorySessionPayload {
  /** @format int32 */
  clientId: number;
  tunnel?: string | null;
  eventPayload?: string | null;
  exceptionDetails?: string | null;
  isProcessed: boolean;
  isDeleted: boolean;
}

/** Data about the item being read at a station */
export interface DataDTOItem {
  /**
   * The EPC data
   * @minLength 0
   * @maxLength 100
   */
  primaryIdentifier?: string | null;
  /**
   * The date and time that the tag was read, including an offset
   * @format date-time
   */
  readTime?: string | null;
  /** Upc */
  upc?: string | null;
}

/** Details of a specific item to edit */
export interface DataDTOItemEdit {
  /** The EPC data */
  epc?: string | null;
  /** Universal Product Code */
  upc?: string | null;
  /**
   * The value that uniquely identifies an instance of an item
   * @format int64
   */
  serialNumber?: number | null;
  /**
   * The status of the item. This dictates how EXO will process the item.<p>Possible values:</p>
   * <ul>
   * <li><b>Purchased</b>: The item was included in a completed sale and the order is now closed.</li>
   * <li><b>Voided</b>: The item is marked as Void and no longer included in the sale.</li>
   * <li><b>Returned</b>: The item was previously purchased but has been returned.</li>
   * <li><b>New</b>: The item will be included in the order, which is still open.</li>
   * </ul>
   */
  itemStatus: DataEnumerationsItemStatus;
  /** Stock Keeping Unit, used to uniquely identify the product */
  sku?: string | null;
}

/** The details of a specific item that has been edited */
export interface DataDTOItemEdited {
  /** The EPC data */
  epc?: string | null;
  /** Universal Product Code */
  upc?: string | null;
  /**
   * The value that uniquely identifies an instance of an item
   * @format int64
   */
  serialNumber?: number | null;
  /**
   * The status of the item<p>Possible values:</p>
   * <ul>
   * <li><b>Purchased</b>: The item was included in a completed sale and the order is now closed.</li>
   * <li><b>Voided</b>: The item is marked as Void and no longer included in the sale.</li>
   * <li><b>Returned</b>: The item was previously purchased but has been returned.</li>
   * <li><b>New</b>: The item will be included in the order, which is still open.</li>
   * </ul>
   */
  itemStatus: DataEnumerationsItemStatus;
  /** Stock Keeping Unit, used to uniquely identify the product */
  sku?: string | null;
}

/** Item View DTO */
export interface DataDTOItemForPosView {
  /** The EPC data */
  epc: string;
  /** Universal Product Code */
  upc?: string | null;
  /**
   * The value that uniquely identifies an instance of an item
   * @format int64
   */
  serialNumber?: number | null;
  /** Stock Keeping Unit, used to uniquely identify the product */
  sku?: string | null;
  /**
   * The status of the item<p>Possible values:</p>
   * <ul>
   * <li><b>Purchased</b>: The item was included in a completed sale and the order is now closed.</li>
   * <li><b>Voided</b>: The item is marked as Void and no longer included in the sale.</li>
   * <li><b>Returned</b>: The item was previously purchased but has been returned.</li>
   * <li><b>New</b>: The item will be included in the order, which is still open.</li>
   * </ul>
   */
  itemStatus: DataEnumerationsItemStatus;
}

/** The details of a specific item that has been reconciled */
export interface DataDTOItemReconciled {
  /** The EPC data */
  epc?: string | null;
  /** Universal Product Code */
  upc?: string | null;
  /**
   * The value that uniquely identifies an instance of an item
   * @format int64
   */
  serialNumber?: number | null;
  /**
   * Indicates whether or not the item is marked as voided. Voided items
   * are not included as part of the sale.
   */
  isVoid: boolean;
  /**
   * The status of the item.<p>Possible values:</p>
   * <ul>
   * <li><b>New</b>: The item should be added to the order in the POS.</li>
   * <li><b>Reconciled</b>: The item was matched with data provided by the POS. No additional action is required for the item.</li>
   * <li><b>IsVoid</b>: The item is marked as voided and not included as part of the sale.</li>
   * </ul>
   */
  status: DataEnumerationsItemReconciledStatus;
  /** Stock Keeping Unit, used to uniquely identify the product */
  sku?: string | null;
}

/** Details of a specific item to reconcile */
export interface DataDTOItemReconciliation {
  /** The EPC data */
  epc?: string | null;
  /** Universal Product Code */
  upc?: string | null;
  /**
   * The value that uniquely identifies an instance of an item
   * @format int64
   */
  serialNumber?: number | null;
  /**
   * Indicates whether or not the item should be marked as Void. Voided items
   * are not included as part of the sale.
   */
  isVoid: boolean;
  /** Stock Keeping Unit, used to uniquely identify the product */
  sku?: string | null;
}

export interface DataDTOItemTrackerCrud {
  /**
   * The RFID EPC data
   * @minLength 0
   * @maxLength 100
   */
  epc?: string | null;
  /**
   * Stock Keeping Unit, used to uniquely identify the product
   * @minLength 0
   * @maxLength 100
   */
  sku?: string | null;
  /**
   * The Universal Product Code, used as an optional identifier if EPC and Sku are null
   * @minLength 0
   * @maxLength 100
   */
  upc?: string | null;
  /**
   * The status of the tracked item<p>Possible values:</p>
   * <ul>
   * <li><b>None</b>: No status</li>
   * <li><b>ExoPurchase</b>: Item was purchased at an Exo station</li>
   * <li><b>ExternalPurchase</b>: For items that were purchased outside Exo</li>
   * <li><b>Ignore</b>: For items that should be ignored</li>
   * <li><b>Alert</b>: For items that should trigger an alert</li>
   * </ul>
   */
  status: DataEnumerationsItemTrackerStatus;
  /**
   * The store ID
   * @format int32
   */
  storeId: number;
  /**
   * Intelligence Point ID associated with the Item Tracker
   * @format int32
   */
  intelligencePointId?: number | null;
}

export interface DataDTOItemTrackerUpdate {
  /** Detailed notes on the tracked item. */
  notes?: string | null;
  /** Client-specific disposition label (e.g., "Item verified on receipt", "Item not found on receipt"). */
  disposition?: string | null;
  /** Soft delete flag to indicate if the item has been marked as hidden. */
  isHidden?: boolean | null;
}

/** Station View DTO */
export interface DataDTOItemTrackerView {
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /** The RFID EPC data */
  epc?: string | null;
  /** Stock Keeping Unit, used to uniquely identify the product */
  sku?: string | null;
  /** The Universal Product Code */
  upc?: string | null;
  /**
   * The status of the tracked item<p>Possible values:</p>
   * <ul>
   * <li><b>None</b>: No status</li>
   * <li><b>ExoPurchase</b>: Item was purchased at an Exo station</li>
   * <li><b>ExternalPurchase</b>: For items that were purchased outside Exo</li>
   * <li><b>Ignore</b>: For items that should be ignored</li>
   * <li><b>Alert</b>: For items that should trigger an alert</li>
   * </ul>
   */
  status: DataEnumerationsItemTrackerStatus;
  /**
   * The store ID
   * @format int32
   */
  storeId: number;
  /**
   * Intelligence Point ID associated with the Item Tracker
   * @format int32
   */
  intelligencePointId?: number | null;
}

/** Combined DTO for ItemTracker that includes product information and detailed fields. */
export interface DataDTOItemTrackerWithProduct {
  /**
   * Item Tracker Identifier.
   * @format int32
   */
  id: number;
  /** The RFID EPC data. */
  epc?: string | null;
  /** Stock Keeping Unit, used to uniquely identify the product. */
  sku?: string | null;
  /**
   * The status of the tracked item.<p>Possible values:</p>
   * <ul>
   * <li><b>None</b>: No status</li>
   * <li><b>ExoPurchase</b>: Item was purchased at an Exo station</li>
   * <li><b>ExternalPurchase</b>: For items that were purchased outside Exo</li>
   * <li><b>Ignore</b>: For items that should be ignored</li>
   * <li><b>Alert</b>: For items that should trigger an alert</li>
   * </ul>
   */
  status: DataEnumerationsItemTrackerStatus;
  /**
   * The store ID.
   * @format int32
   */
  storeId: number;
  /**
   * DateTime the record was created.
   * @format date-time
   */
  createdOn: string;
  /** The product associated with the item tracker. */
  product?: DataDTOProductView | null;
  /** Detailed notes on the tracked item. */
  notes?: string | null;
  /** Client-specific disposition label (e.g., "Item verified on receipt", "Item not found on receipt"). */
  disposition?: string | null;
  /** Soft delete flag to indicate if the item has been marked as hidden. */
  isHidden?: boolean | null;
  /**
   * Intelligence Point ID associated with the Item Tracker
   * @format int32
   */
  intelligencePointId?: number | null;
  /** Universal Product Code (UPC) for the product. */
  upc?: string | null;
}

export interface DataDTOItemTrackersStatusSummary {
  /** @format int32 */
  productId: number;
  productName?: string | null;
  disposition?: string | null;
  /** @format int32 */
  statusCount: number;
  /** @format double */
  totalPriceSum?: number | null;
}

/** Item View DTO */
export interface DataDTOItemView {
  /** Product information associated with the item */
  product?: DataDTOProductView | null;
  /** Item name snapshot. */
  name?: string | null;
  /**
   * Final per-item price after discounts.
   * @format double
   */
  purchasePrice?: number | null;
  /**
   * Total discount applied to the item.
   * @format double
   */
  discountAmount?: number | null;
  /** Discount description */
  discountDescription?: string | null;
  /** Discount title */
  discountTitle?: string | null;
  /** The discount type applied to the item. */
  discountType?: DataEnumerationsItemDiscountType | null;
  /** The EPC data */
  primaryIdentifier: string;
  /**
   * The date and time that the tag was read, including an offset
   * @format date-time
   */
  readTime: string;
  /** Universal Product Code */
  upc?: string | null;
  /** Associated UPC Data */
  upcData?: string | null;
  /**
   * The value that uniquely identifies an instance of an item
   * @format int64
   */
  serialNumber?: number | null;
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /**
   * Product ID
   * @format int32
   */
  productId?: number | null;
  /** Determines if an item is void in the system. */
  itemStatus?: DataEnumerationsItemStatus | null;
  captureMethod?: DataEnumerationsItemCaptureMethod | null;
  sku?: string | null;
}

export interface DataDTOItemsList {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /** ProductSKU */
  sku?: string | null;
  /** Epc */
  epcPrefix?: string | null;
  /** Icon */
  icon?: string | null;
  /** Status */
  status?: DataEnumerationsItemStatus | null;
  /** ExternalId */
  externalId?: string | null;
  /**
   * Retail Price
   * @format double
   */
  price?: number | null;
  /**
   * Final per-item price after discounts.
   * @format double
   */
  purchasePrice?: number | null;
  /**
   * Total discount applied to the item.
   * @format double
   */
  discountAmount?: number | null;
  /** Discount description */
  discountDescription?: string | null;
  /** Discount title */
  discountTitle?: string | null;
  /** The discount type applied to the item. */
  discountType?: DataEnumerationsItemDiscountType | null;
  /** The EPC data */
  primaryIdentifier?: string | null;
  /**
   * The value that uniquely identifies an instance of an item
   * @format int64
   */
  serialNumber?: number | null;
}

export interface DataDTOLocation {
  /** @format int32 */
  id: number;
  name?: string | null;
  description?: string | null;
  integrationType?: DataEnumerationsIntegrationType | null;
  integrationAPIKey?: string | null;
  timezone?: string | null;
  entryPoint?: string | null;
  notes?: string | null;
  isActive: boolean;
  isDeleted: boolean;
  /** @format int32 */
  clientId: number;
  /** @format uuid */
  permanentId?: string | null;
  /** @format date-time */
  createdOn: string;
  /** @format date-time */
  modifiedOn?: string | null;
  createdBy?: string | null;
  modifiedBy?: string | null;
  /** @format int32 */
  version?: number | null;
  client?: DataDTOClientView | null;
}

export interface DataDTOLocationCrud {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @maxLength 1000 */
  description?: string | null;
  integrationType?: DataEnumerationsIntegrationType | null;
  /** @maxLength 255 */
  integrationAPIKey?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  timezone: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  entryPoint: string;
  /** Notes */
  notes?: string | null;
  /** @format int32 */
  clientId: number;
}

export interface DataDTOLogging {
  /**
   * LogLevel enum<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  logLevel: LogLevel;
  /** Message */
  message: string;
  /** Source */
  source: string;
  /** Data for api post */
  data: Record<string, JToken>;
}

export interface DataDTOOperatingScheduleCrud {
  /** List of dates to which the operating schedule will be applied. */
  scheduleDates: string[];
  /**
   * Timespan that represents the starting time in 24-hour format
   * @format date-span
   */
  startTime: string;
  /**
   * Timespan that represents the ending time in 24-hour format
   * @format date-span
   */
  endTime: string;
}

export interface DataDTOOperatingScheduleView {
  /** @format int32 */
  id: number;
  /**
   * The date/time the schedule goes into effect
   * @format date-time
   */
  startTime: string;
  /**
   * The date/time the schedule ends
   * @format date-time
   */
  endTime: string;
}

export interface DataDTOOrder {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** status */
  status?: string | null;
  /** externalId */
  externalId?: string | null;
  /**
   * ModifiedOn
   * @format date-time
   */
  modifiedOn?: string | null;
  /** ModifiedBy */
  modifiedBy?: string | null;
  /**
   * PermanentId
   * @format uuid
   */
  permanentId?: string | null;
  /** ReferenceNumber */
  referenceNumber?: string | null;
  /**
   * ItemCount
   * @format int32
   */
  itemCount: number;
  /**
   * ReadDuration
   * @format double
   */
  readDuration: number;
  /** VoidedFrom */
  voidedFrom?: string | null;
  /** All items for order */
  items: DataDTOItemsList[];
  /** Discount */
  discount?: DataDTODiscountView | null;
  /**
   * Discount Total Amount
   * @format double
   */
  discountTotalAmount?: number | null;
  /**
   * Order-level discount amount
   * @format double
   */
  orderDiscountAmount?: number | null;
  /**
   * The total amount of the order
   * @format double
   */
  totalAmount?: number | null;
  /**
   * The subtotal amount of the order (i.e. before taxes and fees)
   * @format double
   */
  subTotalAmount?: number | null;
  /**
   * The base amount of the order (no taxes, no fees, no discounts)
   * @format double
   */
  baseAmount?: number | null;
  /**
   * Fee Percentage applied to this order
   * @format double
   */
  feePercentage?: number | null;
  /**
   * The total of all fees
   * @format double
   */
  feeTotalAmount?: number | null;
  /**
   * Tax Amount
   * @format double
   */
  taxAmount?: number | null;
}

export interface DataDTOOrderDataFields {
  /** Data field 1 */
  data1?: string | null;
  /** Data field 2 */
  data2?: string | null;
  /** Data field 3 */
  data3?: string | null;
  /** Data field 4 */
  data4?: string | null;
}

export interface DataDTOOrderDetails {
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * The date that the order was completed
   * @format date-time
   */
  completedAt?: string | null;
  /** Reference Number */
  referenceNumber?: string | null;
  /**
   * Tax Amount
   * @format double
   */
  taxAmount?: number | null;
  /**
   * Discount Total Amount
   * @format double
   */
  discountTotalAmount?: number | null;
  /**
   * Order-level discount amount
   * @format double
   */
  orderDiscountAmount?: number | null;
  /**
   * ItemCount
   * @format int32
   */
  itemCount: number;
  /** All items for order */
  items?: DataDTOOrderItemView[] | null;
  /** StationName */
  stationName?: string | null;
  /** Pos */
  pos?: string | null;
  /** StoreName */
  storeName?: string | null;
  /** StoreAddress */
  storeAddress?: DataDTOStoreAddressCrud | null;
  /** Phone */
  phone?: string | null;
  /** ExternalReceiptId */
  externalReceiptId?: string | null;
  /** CreditType */
  creditType?: string | null;
  /** CreditLastFour */
  creditLastFour?: string | null;
  /** CreditType */
  creditAuthorization?: string | null;
  /**
   * The total amount of the order
   * @format double
   */
  totalAmount?: number | null;
  /**
   * The subtotal amount of the order (i.e. before taxes and fees)
   * @format double
   */
  subTotalAmount?: number | null;
  /**
   * Fee Percentage applied to this order
   * @format double
   */
  feePercentage?: number | null;
  /**
   * The total of all fees
   * @format double
   */
  feeTotalAmount?: number | null;
  /**
   * Fee 1
   * @format double
   */
  fee1?: number | null;
  /**
   * Fee 2
   * @format double
   */
  fee2?: number | null;
  /**
   * Fee 3
   * @format double
   */
  fee3?: number | null;
}

/** Station View DTO */
export interface DataDTOOrderForPosView {
  /** Holds order line details */
  items: DataDTOItemForPosView[];
  /** A unique identifier originating from an external system used to find an order. */
  externalId?: string | null;
  /** Alternate identifier to correlate an order in EXO with the POS */
  referenceNumber?: string | null;
}

export interface DataDTOOrderHistory {
  /** @format int32 */
  id: number;
  /** @format date-time */
  modifiedOn?: string | null;
  modifiedBy?: string | null;
  /** Items */
  items: DataDTOOrderHistoryItems[];
  /**
   * Items count
   * @format int32
   */
  itemsCount: number;
  /** summary */
  summary?: string | null;
  /**
   * ReadTime Duration
   * @format double
   */
  readDuration: number;
  /** @format int32 */
  stationId?: number | null;
  /**
   * CreatedAT
   * @format date-time
   */
  createdOn?: string | null;
  station?: DataDTOStationList | null;
  externalId?: string | null;
  /** Reference Number */
  referenceNumber?: string | null;
  /** VoidedFrom */
  voidedFrom?: string | null;
  /**
   * StartedAt
   * @format date-time
   */
  startedAt: string;
  /**
   * CompletedAt
   * @format date-time
   */
  completedAt?: string | null;
}

export interface DataDTOOrderHistoryItemList {
  /**
   * OrderHistory Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /** ProductSKU */
  sku?: string | null;
  /**
   * Final per-item price after discounts.
   * @format double
   */
  purchasePrice?: number | null;
  /**
   * Total discount applied to the item.
   * @format double
   */
  discountAmount?: number | null;
  /** The discount type applied to the item. */
  discountType?: DataEnumerationsItemDiscountType | null;
  /** Epc */
  primaryIdentifier?: string | null;
  /** Icon */
  icon?: string | null;
  /** Status */
  status?: DataEnumerationsItemStatus | null;
  /** VoidedFrom */
  voidedFrom?: string | null;
  /** IsActive */
  isActive: boolean;
  /**
   * How the item was processed.<p>Possible values:</p>
   * <ul>
   * <li><b>Detected</b>: Detected</li>
   * <li><b>ManuallyAdded</b>: ManuallyAdded</li>
   * </ul>
   */
  captureMethod: DataEnumerationsItemCaptureMethod;
  /** Optional supplemental data captured at time of sale (e.g., Treez batch number). */
  data?: string | null;
}

export interface DataDTOOrderHistoryItems {
  /** @format int32 */
  id: number;
  /** @format date-time */
  modifiedOn?: string | null;
  modifiedBy?: string | null;
  /**
   * Product ID
   * @format int32
   */
  productId?: number | null;
  /** Product */
  product?: DataDTOProductView | null;
  /** Item name snapshot. */
  name?: string | null;
  /**
   * Final per-item price after discounts.
   * @format double
   */
  purchasePrice?: number | null;
  /**
   * Total discount applied to the item.
   * @format double
   */
  discountAmount?: number | null;
  /** The discount type applied to the item. */
  discountType?: DataEnumerationsItemDiscountType | null;
  /**
   * Quantity
   * @format int32
   */
  quantity: number;
  /** Used to determine if Exp API has already returned this item to the client. */
  isObserved: boolean;
  /**
   * Item status as Purchased Or Voided<p>Possible values:</p>
   * <ul>
   * <li><b>Purchased</b>: The item was included in a completed sale and the order is now closed.</li>
   * <li><b>Voided</b>: The item is marked as Void and no longer included in the sale.</li>
   * <li><b>Returned</b>: The item was previously purchased but has been returned.</li>
   * <li><b>New</b>: The item will be included in the order, which is still open.</li>
   * </ul>
   */
  itemStatus: DataEnumerationsItemStatus;
  /**
   * How the item was processed.<p>Possible values:</p>
   * <ul>
   * <li><b>Detected</b>: Detected</li>
   * <li><b>ManuallyAdded</b>: ManuallyAdded</li>
   * </ul>
   */
  captureMethod: DataEnumerationsItemCaptureMethod;
  /**
   * OrderHistoryId
   * @format int32
   */
  orderHistoryId: number;
  /**
   * ReadTime
   * @format date-time
   */
  receivedTime: string;
  /** Optional supplemental data captured at time of sale (e.g., Treez batch number). */
  data?: string | null;
}

/** The modifications to make to an order. */
export interface DataDTOOrderItemEdit {
  /** The line item details for the order. */
  items: DataDTOItemEdit[];
  /**
   * Unique client identification number
   * @format int32
   */
  clientId?: number | null;
}

/** The current order details */
export interface DataDTOOrderItemEdited {
  /** The line item details for the order. */
  items: DataDTOItemEdited[];
  /** A unique identifier originating from an external system used to find an order. */
  externalId?: string | null;
}

export interface DataDTOOrderItemView {
  /** The EPC data */
  epc: string;
  /** Universal Product Code */
  upc?: string | null;
  /**
   * The value that uniquely identifies an instance of an item
   * @format int64
   */
  serialNumber?: number | null;
  /** ProductName */
  productName?: string | null;
  /** Item name snapshot. */
  name?: string | null;
  /** ProductPrice */
  productPrice?: string | null;
  /** ProductSku */
  productSku?: string | null;
  /**
   * Final per-item price after discounts.
   * @format double
   */
  purchasePrice?: number | null;
  /**
   * Total discount applied to the item.
   * @format double
   */
  discountAmount?: number | null;
  /** The discount type applied to the item. */
  discountType?: DataEnumerationsItemDiscountType | null;
}

/** The details of the order after being reconciled by EXO. */
export interface DataDTOOrderReconciled {
  /** The line item details for the order. */
  items: DataDTOItemReconciled[];
  /** A unique identifier originating from an external system (POS) used to find an order. */
  externalId?: string | null;
  /** Alternate identifier to correlate an order in EXO with the POS */
  referenceNumber?: string | null;
}

/** The details of the order to reconcile provided by the POS */
export interface DataDTOOrderReconciliation {
  /** The line item details for the order. */
  items: DataDTOItemReconciliation[];
  /** Alternate identifier to correlate an order in EXO with the POS */
  referenceNumber?: string | null;
  /**
   * Unique client identification number
   * @format int32
   */
  clientId?: number | null;
}

export interface DataDTOOrderStatus {
  /**
   * <p>Possible values:</p>
   * <ul>
   * </ul>
   */
  orderStatus: DataEnumerationsOrderStatus;
  /** Gets or sets transient customer lookup data for the Review transition. */
  customerLookup?: DataDTOCustomerLookupAssociation | null;
  /** Gets or sets transient discount-code data for the Review transition. */
  discountCode?: DataDTODiscountCodeAssociation | null;
}

/** Station View DTO */
export interface DataDTOOrderView {
  /** Holds order line details */
  items: DataDTOItemView[];
  /**
   * The date that the order was completed
   * @format date-time
   */
  completedAt?: string | null;
  /**
   * The date that the order was started.
   * @format date-time
   */
  startedAt: string;
  /**
   * The status of this order<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  status: DataEnumerationsOrderStatus;
  externalId?: string | null;
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /** @format uuid */
  permanentId?: string | null;
  /** ReferenceNumber */
  referenceNumber?: string | null;
  /**
   * ItemCount
   * @format int32
   */
  itemCount: number;
  /**
   * ReadDuration
   * @format double
   */
  readDuration: number;
  /** VoidedFrom */
  voidedFrom?: string | null;
  /**
   * Tax Amount
   * @format double
   */
  taxAmount?: number | null;
  /**
   * Discount Total Amount
   * @format double
   */
  discountTotalAmount?: number | null;
  /**
   * Order-level discount amount
   * @format double
   */
  orderDiscountAmount?: number | null;
  /**
   * The total amount of the order
   * @format double
   */
  totalAmount?: number | null;
  /**
   * The base amount of the order (no taxes, no fees, no discounts)
   * @format double
   */
  baseAmount?: number | null;
  /**
   * The subtotal amount of the order (i.e. before taxes and fees)
   * @format double
   */
  subTotalAmount?: number | null;
  /** External Payment Transaction Id */
  externalPaymentTransactionId?: string | null;
  /** ExternalReceiptId */
  externalReceiptId?: string | null;
  /** CreditType */
  creditType?: string | null;
  /** CreditLastFour */
  creditLastFour?: string | null;
  /** CreditType */
  creditAuthorization?: string | null;
  /**
   * The user that authorized the cash payment.
   * @format int32
   */
  cashierUserId?: number | null;
  /**
   * The UTC date and time when the cash payment was authorized.
   * @format date-time
   */
  cashApprovedAt?: string | null;
  /**
   * The final order total collected as cash.
   * @format double
   */
  cashCollectedAmount?: number | null;
  /** Notes recorded for the order. */
  notes?: string | null;
  /**
   * This will contain Fee amount if it exists
   * @format double
   */
  fee1?: number | null;
  /**
   * This will contain another Fee amount if it exists
   * @format double
   */
  fee2?: number | null;
  /**
   * This will contain yet another Fee amount if it exists
   * @format double
   */
  fee3?: number | null;
  /**
   * Fee Percentage applied to this order
   * @format double
   */
  feePercentage?: number | null;
  /**
   * The total of all fees
   * @format double
   */
  feeTotalAmount?: number | null;
}

/** Page CRUD DTO */
export interface DataDTOPageCrud {
  /**
   * Name
   * @minLength 1
   */
  name: string;
  /** Note */
  note?: string | null;
  /** Whether this Page is the default dashboard. Default dashboard is loaded if nothing else is. */
  isDefault?: boolean | null;
  /**
   * Layout JSON, generated from the front-end editor.
   * @minLength 1
   */
  layout: string;
  /** Determines if the report should show up on the reports menu */
  showOnReportsMenu?: boolean | null;
  /**
   * Specifies how often the page refreshes in seconds. Minimum of 5 seconds
   * @format int32
   */
  refreshInterval?: number | null;
}

/** Page CRUD DTO */
export interface DataDTOPageView {
  /** Name */
  name?: string | null;
  /** Note */
  note?: string | null;
  /** Whether this page is the default dashboard. Default dashboard is loaded if nothing else is. */
  isDefault?: boolean | null;
  /** Layout JSON, generated from the front-end editor. */
  layout: string;
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /** Determines if the report should show up on the reports menu */
  showOnReportsMenu?: boolean | null;
  /**
   * Specifies how often the page refreshes in seconds. Minimum of 5 seconds
   * @format int32
   */
  refreshInterval?: number | null;
}

export interface DataDTOPagedDataDataDTOAlertHistoryList {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOAlertHistoryList[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOBoxItemListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOBoxItemListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOClientIntegrationListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOClientIntegrationListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOClientListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOClientListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOClientSsoProviderView {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOClientSsoProviderView[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOConfigProfileListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOConfigProfileListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTODiscountListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTODiscountListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOHealthStatisticsListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOHealthStatisticsListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOIntelligencePointList {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOIntelligencePointList[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOIntelligencePointView {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOIntelligencePointView[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOItemTrackerWithProduct {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOItemTrackerWithProduct[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOLocation {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOLocation[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOProductImportDetailsListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOProductImportDetailsListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOProductImportsListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOProductImportsListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOProductListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOProductListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOStationGroupListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOStationGroupListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOStationList {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOStationList[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOStoreListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOStoreListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOSystemMessageView {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOSystemMessageView[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOTransactionHistory {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOTransactionHistory[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOTunnel {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOTunnel[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOUnknownItemView {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOUnknownItemView[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPagedDataDataDTOUserListing {
  /**
   * Calculates the current page
   * @format int32
   */
  page?: number | null;
  /** @format int32 */
  totalPages: number;
  /** @format int64 */
  totalCount: number;
  rows: DataDTOUserListing[];
  /** @format int32 */
  pageSize?: number | null;
  /** @format int32 */
  skip?: number | null;
}

export interface DataDTOPauseListeningCommand {
  clearCache: boolean;
}

/** Payment Result DTO */
export interface DataDTOPaymentResult {
  /**
   * Transaction Id
   * @format uuid
   */
  transactionId: string;
  /** Payment Method (Credit, Debit, Cash, etc.) */
  paymentMethod: string;
  /** Error Message */
  errorMessage?: string | null;
  /**
   * Fee Amount
   * @format int32
   */
  feeAmount?: number | null;
  /**
   * Tip Amount
   * @format int32
   */
  tipAmount?: number | null;
}

/** Response returned when SSO authentication succeeds but EXO access has not been assigned. */
export interface DataDTOPendingAccessSsoResponse {
  /** SSO completion status. */
  status: string;
  /**
   * Resolved EXO client identifier.
   * @format int32
   */
  clientId: number;
  /** Resolved EXO client name. */
  clientName: string;
  /** User email from EXO or the external identity. */
  email: string;
  /** User first name from EXO or the external identity. */
  firstName?: string | null;
  /** User last name from EXO or the external identity. */
  lastName?: string | null;
  /** Human-readable pending access message. */
  message: string;
}

export interface DataDTOPing {
  /** Status */
  status?: string | null;
  /**
   * RoundTripTime
   * @format int32
   */
  roundTripTime: number;
  /** IpAddress */
  ipAddress?: string | null;
}

export interface DataDTOPosAuthTokenView {
  /** Token */
  token?: string | null;
  /** RefreshToken */
  refreshToken?: string | null;
  /**
   * ExpiresAt
   * @format date-time
   */
  expiresAt?: string | null;
  /** The POS system to use for this station */
  pos?: DataEnumerationsPosSystem | null;
  /** ErrorMessage */
  errorMessage?: string | null;
}

export interface DataDTOPosOrder {
  /** Order Status */
  orderStatus?: DataEnumerationsOrderStatus | null;
  /**
   * Tax Amount
   * @format double
   */
  taxAmount?: number | null;
  /**
   * Discount Total Amount
   * @format double
   */
  discountTotalAmount?: number | null;
  /**
   * The order base amount - equivalent to the sum of items at full price.
   * @format double
   */
  baseAmount?: number | null;
  /**
   * The subtotal amount of the order.
   * @format double
   */
  subTotalAmount?: number | null;
  /**
   * The total amount of the order.
   * @format double
   */
  totalAmount?: number | null;
  /**
   * This will contain Fee amount if it exists
   * @format double
   */
  fee1?: number | null;
  /**
   * This will contain another Fee amount if it exists
   * @format double
   */
  fee2?: number | null;
  /**
   * This will contain yet another Fee amount if it exists
   * @format double
   */
  fee3?: number | null;
  /**
   * The total of all fees.
   * @format double
   */
  feeTotalAmount?: number | null;
  /**
   * Order-level discount amount
   * @format double
   */
  orderDiscountAmount?: number | null;
  /** External Payment Transaction Id */
  externalPaymentTransactionId?: string | null;
}

/** POS type data exposed to clients. */
export interface DataDTOPosTypeView {
  /**
   * POS type identifier (matches Stark.EXO.API.Data.Enumerations.PosSystem enum value).
   * @format int32
   */
  id: number;
  /** POS system name (matches Stark.EXO.API.Data.Enumerations.PosSystem enum name). */
  name: string;
}

/** Represents the response of a preview ticket from Treez */
export interface DataDTOPreviewTicketResponse {
  /**
   * Station Permanent Id
   * @format uuid
   */
  stationPermanentId: string;
  /** Reason */
  reason: string;
  /** Detail */
  detail: string;
}

export interface DataDTOProductCrud {
  /** Reference */
  reference?: string | null;
  /**
   * Name
   * @minLength 0
   * @maxLength 300
   */
  name: string;
  /**
   * Type (ex. shirts, hats)
   * @minLength 0
   * @maxLength 200
   */
  type: string;
  /**
   * Icon
   * @minLength 0
   * @maxLength 2000
   */
  icon?: string | null;
  /**
   * Description
   * @minLength 0
   * @maxLength 1000
   */
  description?: string | null;
  /**
   * SKU
   * @minLength 0
   * @maxLength 100
   */
  sku: string;
  /** ProductUpcs */
  productUpcs: DataDTOProductUpcCrud[];
  /**
   * EPC Prefix (minus the serialization)
   * @minLength 0
   * @maxLength 100
   */
  epcPrefix?: string | null;
  /**
   * Image URL
   * @minLength 0
   * @maxLength 2000
   */
  imageUrl?: string | null;
  /** Notes */
  notes?: string | null;
  /** IsDeleted */
  isDeleted: boolean;
  /** Color */
  color?: string | null;
  /** Size */
  size?: string | null;
  /**
   * Price
   * @format double
   */
  price?: number | null;
  /** IsAvailableForHotButton */
  isAvailableForHotButton: boolean;
  /**
   * ExternalId
   * @minLength 0
   * @maxLength 256
   */
  externalId?: string | null;
  /** @format int32 */
  clientId: number;
}

/** Holds FileId and Filename information related to a product import */
export interface DataDTOProductCsvImportIdentifier {
  /** @format uuid */
  fileId?: string | null;
  filename?: string | null;
}

export interface DataDTOProductDebug {
  product?: DataDTOProductView | null;
  upcToFindProduct?: string | null;
  tag?: StructuredTag | null;
  primaryIdentifierForItem?: string | null;
  upcForItem?: string | null;
  isHotKeyItem: boolean;
  /**
   * <p>Possible values:</p>
   * <ul>
   * <li><b>Detected</b>: Detected</li>
   * <li><b>ManuallyAdded</b>: ManuallyAdded</li>
   * </ul>
   */
  captureMethod: DataEnumerationsItemCaptureMethod;
}

export interface DataDTOProductImport {
  /**
   * Name
   * @minLength 0
   * @maxLength 300
   */
  name: string;
  /**
   * Description
   * @minLength 0
   * @maxLength 1000
   */
  description?: string | null;
  /**
   * SKU
   * @minLength 0
   * @maxLength 100
   */
  sku: string;
  /**
   * Compatibility field for older plain-UPC import payloads. Each item still
   * represents a UPC entry. New callers should use UpcsWithData instead.
   */
  upcs: string[];
  /** Preferred import shape where each UPC can optionally carry its own Data value. */
  upcsWithData: DataDTOProductImportUpcWithData[];
  /** EPC Prefix */
  epcPrefix?: string | null;
  /**
   * Icon
   * @minLength 0
   * @maxLength 2000
   */
  icon?: string | null;
  /** ImageUrl */
  imageUrl?: string | null;
  /**
   * Type
   * @minLength 0
   * @maxLength 200
   */
  type: string;
  /**
   * Notes
   * @minLength 0
   * @maxLength 5000
   */
  notes?: string | null;
  /** Reference */
  reference?: string | null;
  /** Color */
  color?: string | null;
  /** Size */
  size?: string | null;
  /** Retail Price */
  price?: string | null;
  /** IsAvailableForHotButton */
  isAvailableForHotButton: boolean;
  /**
   * Type
   * @minLength 0
   * @maxLength 250
   */
  externalId?: string | null;
  /** Type */
  deleted?: boolean | null;
  version?: string | null;
  /**
   * Compatibility field for older import payloads. This is never treated as a
   * standalone value; during normalization it is attached to UPC entries that
   * do not already provide Data. New callers should use UpcsWithData[].Data instead.
   * @minLength 0
   * @maxLength 100
   */
  upcData?: string | null;
  /**
   * Data1
   * @minLength 0
   * @maxLength 2000
   */
  data1?: string | null;
  /**
   * Data2
   * @minLength 0
   * @maxLength 2000
   */
  data2?: string | null;
  /**
   * Data3
   * @minLength 0
   * @maxLength 2000
   */
  data3?: string | null;
  /**
   * Data4
   * @minLength 0
   * @maxLength 2000
   */
  data4?: string | null;
}

export interface DataDTOProductImportDetails {
  dto?: DataDTOProductImport | null;
  /**
   * <p>Possible values:</p>
   * <ul>
   * </ul>
   */
  action: DataDTOProductImportDetailsActionType;
  /** Message */
  message?: string | null;
  /**
   * Record Number
   * @format int32
   */
  recordNumber: number;
  /**
   * Existing product IDs involved in conflicts as JSON array of ints.
   * Used when a single importing row conflicts with multiple products.
   */
  conflictProductIdsJson?: string | null;
  /**
   * Product ID created/updated/deleted by this import row.
   * @format int32
   */
  affectedProductId?: number | null;
  /** File Name */
  fileName?: string | null;
  source?: string | null;
}

export interface DataDTOProductImportDetailsListing {
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * Action<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  action: DataDTOProductImportDetailsActionType;
  /** Deleted */
  deleted?: boolean | null;
  /** Color */
  color?: string | null;
  /** Description */
  description?: string | null;
  /** EpcPrefix */
  epcPrefix?: string | null;
  /** Icon */
  icon?: string | null;
  /** ImageUrl */
  imageUrl?: string | null;
  /** Name */
  name?: string | null;
  /** Notes */
  notes?: string | null;
  /** Retail Price */
  price?: string | null;
  /** Message */
  message?: string | null;
  /**
   * PermanentId
   * @format uuid
   */
  permanentId?: string | null;
  /** FileName */
  fileName?: string | null;
  /** Source */
  source?: string | null;
  /**
   * Record number (1-based) of the importing row.
   * @format int32
   */
  recordNumber?: number | null;
  /** Incoming product SKU. */
  incomingSku?: string | null;
  /** Incoming product ExternalId. */
  incomingExternalId?: string | null;
  /** Normalized list of incoming UPCs as JSON array of strings. */
  incomingUpcsJson?: string | null;
  /**
   * Existing product IDs involved in conflicts as JSON array of ints.
   * Used when a single importing row conflicts with multiple products.
   */
  conflictProductIdsJson?: string | null;
  /**
   * Product ID created/updated/deleted by this import row.
   * @format int32
   */
  affectedProductId?: number | null;
  /** @format int32 */
  productImportId: number;
  /**
   * ModifiedOn
   * @format date-time
   */
  modifiedOn?: string | null;
  /** ModifiedBy */
  modifiedBy?: string | null;
  /**
   * CreatedOn
   * @format date-time
   */
  createdOn?: string | null;
}

export interface DataDTOProductImportStart {
  /** FileName */
  fileName?: string | null;
  /** Source */
  source?: string | null;
  /**
   * ClientId
   * @format int32
   */
  clientId: number;
}

export interface DataDTOProductImportSummary {
  /** Imports */
  details: DataDTOProductImportDetails[];
  /**
   * Total Imported
   * @format int32
   */
  importCount: number;
  /**
   * Products Added
   * @format int32
   */
  productsAdded: number;
  /**
   * Products Updated
   * @format int32
   */
  productsUpdated: number;
  /**
   * Projects Rejected
   * @format int32
   */
  productsRejected: number;
  /** @format int32 */
  productsDeleted: number;
  /** @format int32 */
  productsUnchanged: number;
  /**
   * The file upload ID
   * @format uuid
   */
  fileId?: string | null;
}

/** Represents a single UPC entry within a product import payload. */
export interface DataDTOProductImportUpcWithData {
  /**
   * UPC value for the product.
   * @minLength 0
   * @maxLength 100
   */
  upc?: string | null;
  /**
   * Optional supplemental data associated with this UPC entry (e.g., Treez batch number).
   * @minLength 0
   * @maxLength 100
   */
  data?: string | null;
}

export interface DataDTOProductImportsListing {
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * StartTime
   * @format date-time
   */
  startTime: string;
  /**
   * EndTime
   * @format date-time
   */
  endTime: string;
  /** FileName */
  fileName?: string | null;
  /** Source */
  source?: string | null;
  /**
   * ProductsAdded
   * @format int32
   */
  productsAdded: number;
  /**
   * ProductsUpdated
   * @format int32
   */
  productsUpdated: number;
  /**
   * FailedProducts
   * @format int32
   */
  failedProducts: number;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /**
   * CreatedOn
   * @format date-time
   */
  createdOn?: string | null;
  /**
   * ClientId
   * @format int32
   */
  clientId: number;
  /** Status */
  status?: DataEnumerationsProductImportStatus | null;
  /**
   * PermanentId
   * @format uuid
   */
  permanentId: string;
}

export interface DataDTOProductImportsView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * StartTime
   * @format date-time
   */
  startTime: string;
  /**
   * EndTime
   * @format date-time
   */
  endTime: string;
  /** FileName */
  fileName?: string | null;
  /** Source */
  source?: string | null;
  /**
   * ProductsAdded
   * @format int32
   */
  productsAdded: number;
  /**
   * ProductsUpdated
   * @format int32
   */
  productsUpdated: number;
  /**
   * FailedProducts
   * @format int32
   */
  failedProducts: number;
  /**
   * ClientId
   * @format int32
   */
  clientId: number;
  /** Status */
  status?: DataEnumerationsProductImportStatus | null;
  /** @format uuid */
  permanentId: string;
}

/** Holds FileId and Filename information related to a product import */
export interface DataDTOProductJsonImportIdentifier {
  /** @format uuid */
  importProcessId?: string | null;
}

export interface DataDTOProductListing {
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Image URL */
  imageUrl?: string | null;
  /** Type (ex. shirts, hats) */
  type?: string | null;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /** IsDeleted */
  isDeleted: boolean;
  /**
   * CreatedOn
   * @format date-time
   */
  createdOn?: string | null;
  /** Reference */
  reference?: string | null;
  /** Color */
  color?: string | null;
  /** Size */
  size?: string | null;
  /** Sku */
  sku?: string | null;
  /** Comma seprated upcs values for Grid api */
  upcs?: string | null;
  /**
   * Retail Price
   * @format double
   */
  price?: number | null;
  /** IsAvailableForHotButton */
  isAvailableForHotButton: boolean;
  /** ExternalId */
  externalId?: string | null;
  /** EPC Prefix (minus the serialization) */
  epcPrefix?: string | null;
  /** Icon */
  icon?: string | null;
}

export interface DataDTOProductUpcCrud {
  /**
   * Upc
   * @minLength 1
   */
  upc: string;
  /**
   * ProductId
   * @format int32
   */
  productId: number;
  /**
   * Optional supplemental data associated with this UPC entry (e.g., Treez batch number).
   * @minLength 0
   * @maxLength 100
   */
  data?: string | null;
}

/** Bulk request payload for syncing UPC data for one client. */
export interface DataDTOProductUpcDataSync {
  /**
   * Client identifier for the sync request.
   * @format int32
   */
  clientId: number;
  /** Optional client name used for validation and logging. */
  clientName?: string | null;
  /** Products to sync. */
  products: DataDTOProductUpcDataSyncProduct[];
  /** Holds tracking information about the sync process. */
  tracking: DataDTOProductUpcDataSyncTrackingInfo;
}

/** Detail record for a UPC data sync operation. */
export interface DataDTOProductUpcDataSyncDetail {
  /** External identifier processed for this detail record. */
  externalId?: string | null;
  /** SKU processed for this detail record. */
  sku?: string | null;
  /** UPC processed for this detail record. */
  upc?: string | null;
  /**
   * Final action taken.<p>Possible values:</p>
   * <ul>
   * </ul>
   */
  action: DataDTOProductUpcDataSyncDetailActionType;
  /** Optional detail message for the caller. */
  message?: string | null;
}

/** UPC data sync request for a single product. */
export interface DataDTOProductUpcDataSyncProduct {
  /**
   * Product external identifier used to identify the product within the client.
   * @minLength 0
   * @maxLength 100
   */
  externalId?: string | null;
  /**
   * Product SKU used to identify the product within the client when no external identifier is provided.
   * @minLength 0
   * @maxLength 100
   */
  sku?: string | null;
  /** UPC entries to sync for the product. */
  upcs: DataDTOProductUpcWithData[];
}

/** Summary response for a UPC data sync operation. */
export interface DataDTOProductUpcDataSyncSummary {
  /** Detail rows describing the action taken for each requested UPC. */
  details: DataDTOProductUpcDataSyncDetail[];
  /**
   * Number of distinct products processed in this sync.
   * @format int32
   */
  productsProcessed: number;
  /**
   * Number of UPCs added.
   * @format int32
   */
  upcsAdded: number;
  /**
   * Number of UPCs updated.
   * @format int32
   */
  upcsUpdated: number;
  /**
   * Number of UPCs left unchanged.
   * @format int32
   */
  upcsUnchanged: number;
  /**
   * Number of failed UPC sync detail rows.
   * @format int32
   */
  failures: number;
}

/** Tracking metadata for the sync process. */
export interface DataDTOProductUpcDataSyncTrackingInfo {
  /** Who initiated the sync process. */
  source?: string | null;
  /** Identifier to track the sync from the source. */
  reference?: string | null;
}

export interface DataDTOProductUpcView {
  /** ProductId */
  productId?: string | null;
  /** Upc */
  upc?: string | null;
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * ModifiedOn
   * @format date-time
   */
  modifiedOn?: string | null;
  /** ModifiedBy */
  modifiedBy?: string | null;
  /** Optional supplemental data associated with this UPC entry (e.g., Treez batch number). */
  data?: string | null;
}

/** Represents a single UPC entry with supplemental data. */
export interface DataDTOProductUpcWithData {
  /**
   * UPC value to sync to the product.
   * @minLength 1
   */
  upc: string;
  /** Supplemental data to store for the UPC. */
  data?: string | null;
}

/** Station View DTO */
export interface DataDTOProductView {
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** SKU */
  sku: string;
  /** EPC Prefix (minus the serialization) */
  epcPrefix?: string | null;
  /** Icon */
  icon?: string | null;
  /** Image URL */
  imageUrl?: string | null;
  /** Manufacturer */
  manufacturer?: string | null;
  /**
   * Retail Price
   * @format double
   */
  price?: number | null;
  /** Type (ex. shirts, hats) */
  type?: string | null;
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  createdOn?: string | null;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /** IsDeleted */
  isDeleted: boolean;
  /** Notes */
  notes?: string | null;
  /** Reference */
  reference?: string | null;
  /** Color */
  color?: string | null;
  /** Size */
  size?: string | null;
  /** ProductUpcs */
  productUpcs: DataDTOProductUpcView[];
  /** IsAvailableForHotButton */
  isAvailableForHotButton: boolean;
  /** ExternalId */
  externalId?: string | null;
  /** Data1 */
  data1?: string | null;
  /** Data2 */
  data2?: string | null;
  /** Data3 */
  data3?: string | null;
  /** Data4 */
  data4?: string | null;
}

/** Product and tracker stat information */
export interface DataDTOProductWithAlert {
  /** @format int32 */
  clientId?: number | null;
  color?: string | null;
  createdBy?: string | null;
  /** @format date-time */
  createdOn: string;
  data1?: string | null;
  data2?: string | null;
  data3?: string | null;
  data4?: string | null;
  description?: string | null;
  epcPrefix?: string | null;
  externalId?: string | null;
  externalVersion?: string | null;
  icon?: string | null;
  /** @format int32 */
  id: number;
  imageUrl?: string | null;
  isDeleted: boolean;
  manufacturer?: string | null;
  modifiedBy?: string | null;
  /** @format date-time */
  modifiedOn: string;
  /** @format date-time */
  mostRecentTrackerTime: string;
  /** @format int32 */
  trackerCount: number;
  name: string;
  notes?: string | null;
  /** @format uuid */
  permanentId?: string | null;
  /** @format double */
  price?: number | null;
  reference?: string | null;
  size?: string | null;
  sku: string;
  type?: string | null;
  /** @format int32 */
  version?: number | null;
}

/** DTO for requesting certain EventTypes to be published to the service bus */
export interface DataDTOPublishMessageRequest {
  /**
   * The event type to publish<p>Possible values:</p>
   * <ul>
   * <li><b>CustomerLookup</b>: Customer lookup event for retrieving customer information by phone number</li>
   * <li><b>Checkout</b>: Checkout initiation event for Treez preview flow</li>
   * <li><b>PaymentResult</b>: Payment result event for Treez payment completion flow</li>
   * <li><b>DiscountLookup</b>: Discount code lookup event for retrieving discount information by code</li>
   * </ul>
   */
  eventType: DataEnumerationsEventType;
  /**
   * Gets or sets the identifier used to look up the customer.
   * @minLength 0
   * @maxLength 50
   */
  identifier?: string | null;
  /**
   * Gets or sets the phone number accepted from legacy Treez Checkout clients.
   * @minLength 0
   * @maxLength 50
   */
  phoneNumber?: string | null;
  /**
   * Treez Associated Customer Id
   * @format int32
   */
  customerId?: number | null;
  /** Gets or sets the result of the payment operation. */
  paymentResultDto?: DataDTOPaymentResult | null;
}

export interface DataDTOReaderJson {
  /** Reader Name */
  name?: string | null;
  /** Reader Status */
  status?: string | null;
}

/** Reader Override DTO */
export interface DataDTOReaderOverride {
  /** Antenna Configuration */
  antennaConfiguration: DataDTOAntennaOverride[];
  /** Enabled */
  enabled: boolean;
  /**
   * ID
   * @format int32
   */
  id: number;
  /**
   * IP Address
   * @minLength 1
   */
  ipAddress: string;
  /**
   * Min RSSI
   * @format int32
   */
  minRssi: number;
  /**
   * Min Stream Read Count
   * @format int32
   */
  minStreamReadCount: number;
  /**
   * Port
   * @format int32
   */
  port: number;
  /**
   * Power Level
   * @format int32
   */
  powerLevel: number;
  /**
   * Read Count Persist Time
   * @format int32
   */
  readCountPersistTime: number;
  /**
   * Reader Configuration ID
   * @format int32
   * @min 1
   * @max 2147483647
   */
  readerConfigurationId: number;
  /** Reader Model */
  readerModel?: string | null;
  /** Reader Name */
  readerName?: string | null;
  /** Search Mode */
  searchMode?: string | null;
  /**
   * Session
   * @format int32
   */
  session: number;
  /**
   * AntennaDwellTime
   * @format int32
   */
  antennaDwellTime?: number | null;
}

/** Reader View DTO */
export interface DataDTOReaderView {
  /** Antenna Configuration */
  antennaConfiguration: DataDTOAntennaView[];
  /**
   * Configuration Profile ID
   * @format int32
   */
  configurationProfileId: number;
  /** Enabled */
  enabled: boolean;
  /**
   * ID
   * @format int32
   */
  id: number;
  /** IP Address */
  ipAddress?: string | null;
  /**
   * Min RSSI
   * @format int32
   */
  minRssi: number;
  /**
   * Min Stream Read Count
   * @format int32
   */
  minStreamReadCount: number;
  /**
   * Port
   * @format int32
   */
  port: number;
  /**
   * Power Level
   * @format int32
   */
  powerLevel: number;
  /**
   * Read Count Persist Time
   * @format int32
   */
  readCountPersistTime: number;
  /** Reader Model */
  readerModel?: string | null;
  /** Name */
  readerName?: string | null;
  /** Search Mode */
  searchMode?: string | null;
  /**
   * Session
   * @format int32
   */
  session: number;
  /**
   * AntennaDwellTime
   * @format int32
   */
  antennaDwellTime?: number | null;
}

export interface DataDTOReads {
  /** Data */
  data: number[];
  /** Labels */
  labels: string[];
  /** Timezone */
  timezone?: string | null;
}

/** Holds information about an order's receipt */
export interface DataDTOReceiptView {
  /** The receipt's HTML */
  html?: string | null;
}

export interface DataDTOReferenceNumber {
  /** Reference Number for an Order */
  referenceNumber?: string | null;
}

/** Request to ensure that a client's Shopify offline access token is usable. */
export interface DataDTORefreshShopifyToken {
  /** Indicates whether Shopify should be contacted even when the current access token is outside the refresh window. */
  forceRefresh: boolean;
  /**
   * Optional caller-supplied operational context that is intentionally not persisted or logged.
   * @maxLength 500
   */
  reason?: string | null;
}

/** RegisterStationViewDto */
export interface DataDTORegisterStationView {
  /**
   * PermanentId
   * @format uuid
   */
  permanentId?: string | null;
  /** AccessToken */
  accessToken?: string | null;
}

/** Information that dictates how EXO should handle the reset. */
export interface DataDTOResetOrder {
  /** For internal use. This should be set to `false` by external systems. */
  isValidatorApp: boolean;
  /**
   * For a completed transaction, this value should be null. If the
   * transaction is voided, this is used to indicate which system voided
   * the order.
   */
  voidedFrom?: string | null;
  /**
   * This is an optional field to place additional information about
   * a completed or voided order.
   */
  notes?: string | null;
  /** The external ID of the customer associated with the order. */
  customerExternalId?: string | null;
  /** The phone number of the customer associated with the order. */
  customerPhone?: string | null;
  /** The name of the customer associated with the order. */
  customerName?: string | null;
}

/** RFID Reader CRUD DTO */
export interface DataDTORfidReaderCrud {
  /** Antennas */
  antennas: DataDTOAntennaCrud[];
  /** Enabled */
  enabled: boolean;
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * IpAddress
   * @minLength 1
   */
  ipAddress: string;
  /**
   * MinRssi
   * @format int32
   */
  minRssi: number;
  /**
   * MinStreamRedCount
   * @format int32
   */
  minStreamReadCount: number;
  /**
   * Port
   * @format int32
   */
  port: number;
  /**
   * PowerLevel
   * @format int32
   */
  powerLevel: number;
  /**
   * ReadCountPersistTime
   * @format int32
   */
  readCountPersistTime: number;
  /** ReaderModel */
  readerModel?: string | null;
  /** ReaderName */
  readerName?: string | null;
  /** SearchMode */
  searchMode?: string | null;
  /**
   * Session
   * @format int32
   */
  session: number;
  /**
   * AntennaDwellTime
   * @format int32
   */
  antennaDwellTime?: number | null;
}

export interface DataDTORfidReaderHealth {
  /** Name */
  name?: string | null;
  /** Status */
  status?: string | null;
  /** Ping */
  ping?: DataDTOPing | null;
}

export interface DataDTORfidReaderHealthView {
  /** Name */
  name?: string | null;
  /** Status */
  status?: string | null;
  /** PingStatus */
  pingStatus?: string | null;
  /**
   * RoundtripTime
   * @format int32
   */
  roundtripTime?: number | null;
  /** IpAddress */
  ipAddress?: string | null;
  /**
   * HealthStatusId
   * @format int32
   */
  healthStatusId: number;
}

export interface DataDTORfidReadersListing {
  /** ReaderModel */
  readerModel?: string | null;
  /** ReaderName */
  readerName?: string | null;
  /**
   * AntennaQuantity
   * @format int32
   */
  antennaQuantity: number;
  /**
   * Port
   * @format int32
   */
  port: number;
  /** Session */
  session?: string | null;
  /** PowerLevel */
  powerLevel?: string | null;
  /** MinRSSI */
  minRSSI?: string | null;
  /** MinStreamCount */
  minStreamCount?: string | null;
  /** ReadCountPersistTime */
  readCountPersistTime?: string | null;
  /** SearchMode */
  searchMode?: string | null;
  /**
   * AntennaDwellTime
   * @format int32
   */
  antennaDwellTime?: number | null;
}

export interface DataDTORfidTagPrinted {
  /**
   * PrintedAt
   * @format date-time
   */
  printedAt?: string | null;
  /** Schema */
  schema?: EncodingSchema | null;
  /** Epcs list for RfidTagPrinted */
  epcs: string[];
}

export interface DataDTOSasToken {
  /** @minLength 1 */
  resourceUri: string;
  /** @minLength 1 */
  keyName: string;
  /** @minLength 1 */
  key: string;
  /** @format int32 */
  expiry: number;
}

/** Used for emailing a receipt */
export interface DataDTOSendReceipt {
  /** The email address to send the receipt to */
  email?: string | null;
}

/** EXO for submitting create / update requests */
export interface DataDTOServiceAccountCrud {
  /**
   * Name
   * @minLength 0
   * @maxLength 100
   */
  name: string;
  /**
   * Notes
   * @minLength 0
   * @maxLength 2000
   */
  notes?: string | null;
  /**
   * RemoteUrl
   * @minLength 0
   * @maxLength 200
   */
  remoteUrl?: string | null;
  /**
   * Username
   * @minLength 0
   * @maxLength 100
   */
  username?: string | null;
  /**
   * Password
   * @minLength 0
   * @maxLength 1000
   */
  password?: string | null;
  /**
   * Port
   * @format int32
   */
  port?: number | null;
  /** UseSsl */
  useSsl?: boolean | null;
  /** Service Account Type */
  type?: DataEnumerationsServiceAccountType | null;
  /** DataField1 */
  data?: string | null;
  /** Change Password */
  changePassword: boolean;
  /** New Password */
  newPassword?: string | null;
}

/** EXO DTO */
export interface DataDTOServiceAccountView {
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /** Notes */
  notes?: string | null;
  /** RemoteUrl */
  remoteUrl?: string | null;
  /** Username */
  username?: string | null;
  /** Password */
  password?: string | null;
  /**
   * Port
   * @format int32
   */
  port?: number | null;
  /** UseSsl */
  useSsl?: boolean | null;
  /** DataField1 */
  data?: string | null;
  /** Service Account Type */
  type?: DataEnumerationsServiceAccountType | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
}

export interface DataDTOSetReferenceNumber {
  /** ReferenceNumber */
  referenceNumber?: string | null;
}

/** First DTO. Don't hurt his feelings. He's just a guinea pig. */
export interface DataDTOSettingCrud {
  /** Determines the type of control to use in the UI, as well as points to the Value property to use */
  uiHint?: DataEnumerationsUiHint | null;
  /** Since Names are required to be unique, Label allows the UI to show a non-unique value. */
  label?: string | null;
  /**
   * Holds a string value
   * @minLength 0
   * @maxLength 2000
   */
  stringValue?: string | null;
  /** Update Encrypted StringValue */
  updateEncryptedStringValue: boolean;
  /** New Encrypted StringValue */
  newEncryptedStringValue?: string | null;
  /**
   * Holds an int value
   * @format int32
   */
  intValue?: number | null;
  /**
   * Holds a double value
   * @format double
   */
  doubleValue?: number | null;
  /**
   * Holds a decimal value
   * @format double
   */
  decimalValue?: number | null;
  /** Holds a boolean value */
  boolValue?: boolean | null;
  /**
   * Holds a date+time value (with offset)
   * @format date-time
   */
  dateTimeValue?: string | null;
  /** Specifies a C# format string to be used when displaying the value. See https://docs.microsoft.com/en-us/dotnet/api/system.string.format?view=netframework-4.8#remarks-top */
  format?: string | null;
  /** When UiHint is a list type, ListValues can contain a list of values to be used as options */
  listValues?: string | null;
  /**
   * Can be used for basic validation of `StringValue`
   * @minLength 0
   * @maxLength 2000
   */
  regexValidation?: string | null;
  /**
   * The unique name of the setting
   * @minLength 0
   * @maxLength 100
   */
  name: string;
  /**
   * The setting description
   * @minLength 0
   * @maxLength 2000
   */
  description?: string | null;
}

export interface DataDTOSettingView {
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /** Determines the type of control to use in the UI, as well as points to the Value property to use */
  uiHint?: DataEnumerationsUiHint | null;
  /** Since Names are required to be unique, Label allows the UI to show a non-unique value. */
  label?: string | null;
  /** Holds a string value */
  stringValue?: string | null;
  /**
   * Holds an int value
   * @format int32
   */
  intValue?: number | null;
  /**
   * Holds a double value
   * @format double
   */
  doubleValue?: number | null;
  /**
   * Holds a decimal value
   * @format double
   */
  decimalValue?: number | null;
  /** Holds a boolean value */
  boolValue?: boolean | null;
  /**
   * Holds a date+time value (with offset)
   * @format date-time
   */
  dateTimeValue?: string | null;
  /** Specifies a C# format string to be used when displaying the value. See https://docs.microsoft.com/en-us/dotnet/api/system.string.format?view=netframework-4.8#remarks-top */
  format?: string | null;
  /** When UiHint is a list type, ListValues can contain a list of values to be used as options */
  listValues?: string | null;
  /** Can be used for basic validation of `StringValue` */
  regexValidation?: string | null;
  /** The unique name of the setting */
  name?: string | null;
  /** The setting description */
  description?: string | null;
}

/** Secret-free Shopify installation and token-maintenance status for an EXO client. */
export interface DataDTOShopifyClientInstallationStatus {
  /**
   * EXO client identifier.
   * @format int32
   */
  clientId: number;
  /**
   * Permanent Shopify installation identifier when an installation exists.
   * @format uuid
   */
  shopifyInstallationId?: string | null;
  /** Canonical myshopify.com domain when an installation exists. */
  myShopifyDomain?: string | null;
  /**
   * Shopify application lifecycle status.<p>Possible values:</p>
   * <ul>
   * <li><b>None</b>: No installation lifecycle status has been assigned.</li>
   * <li><b>Installed</b>: The Shopify application is installed on the shop.</li>
   * <li><b>Uninstalled</b>: The Shopify shop has uninstalled the EXO Shopify app.</li>
   * <li><b>Revoked</b>: Shopify access for this installation has been revoked.</li>
   * </ul>
   */
  installationStatus: DataEnumerationsShopifyInstallationStatus;
  /**
   * EXO client-link lifecycle status.<p>Possible values:</p>
   * <ul>
   * <li><b>Unlinked</b>: The Shopify installation is not linked to an EXO client.</li>
   * <li><b>Linked</b>: The Shopify installation is linked to an EXO client.</li>
   * <li><b>RequiresRelink</b>: The previous EXO client link must be established again.</li>
   * </ul>
   */
  linkStatus: DataEnumerationsShopifyInstallationLinkStatus;
  /** Indicates whether the Shopify app is installed and actively linked. */
  isInstalled: boolean;
  /** Indicates whether the Shopify shop must complete the relink workflow. */
  requiresRelink: boolean;
  /**
   * Date and time when the app was most recently installed.
   * @format date-time
   */
  installedAtUtc?: string | null;
  /**
   * Date and time when the app was uninstalled.
   * @format date-time
   */
  uninstalledAtUtc?: string | null;
  /**
   * Date and time when the installation was linked to the EXO client.
   * @format date-time
   */
  linkedAtUtc?: string | null;
  /**
   * Date and time when the offline token was most recently refreshed successfully.
   * @format date-time
   */
  lastTokenRefreshAtUtc?: string | null;
  /**
   * Date and time when the most recent token refresh failed.
   * @format date-time
   */
  tokenRefreshFailedAtUtc?: string | null;
  /** Secret-free category for the most recent token refresh failure. */
  tokenRefreshFailureCategory?: DataEnumerationsShopifyTokenRefreshFailureCategory | null;
  /**
   * Earliest date and time when token maintenance should retry.
   * @format date-time
   */
  nextTokenRefreshAttemptAtUtc?: string | null;
}

/** A usable Shopify offline access token for an authorized internal service. */
export interface DataDTOShopifyClientToken {
  /**
   * EXO client identifier.
   * @format int32
   */
  clientId: number;
  /**
   * Permanent Shopify installation identifier.
   * @format uuid
   */
  shopifyInstallationId: string;
  /** Canonical myshopify.com domain. */
  myShopifyDomain: string;
  /** Decrypted Shopify access token. */
  accessToken: string;
  /** Comma-delimited scopes granted to the access token. */
  scopes: string;
  /** Shopify access mode for this token. */
  accessMode: string;
  /**
   * Date and time when the access token expires.
   * @format date-time
   */
  accessTokenExpiresAtUtc: string;
  /**
   * Date and time when the refresh token expires.
   * @format date-time
   */
  refreshTokenExpiresAtUtc: string;
}

/** Shopify installation and EXO client link information. */
export interface DataDTOShopifyInstallationClient {
  /**
   * Short-lived session JWT issued by Shopify App Bridge.
   * @minLength 1
   */
  shopifySessionJwt: string;
  /**
   * EXO client identifier.
   * @format int32
   */
  clientId: number;
}

/** Shopify session information used to get the current installation state. */
export interface DataDTOShopifyInstallationCurrent {
  /**
   * Short-lived session JWT issued by Shopify App Bridge.
   * @minLength 1
   */
  shopifySessionJwt: string;
}

/** Identifies a Shopify shop for an installation lifecycle operation. */
export interface DataDTOShopifyInstallationShop {
  /**
   * Canonical Shopify shop domain.
   * @minLength 1
   * @maxLength 255
   */
  shop: string;
}

/** Request to record a Shopify application uninstall. */
export interface DataDTOShopifyInstallationUninstall {
  /**
   * Canonical Shopify shop domain.
   * @minLength 1
   * @maxLength 255
   */
  shop: string;
}

/** Shopify installation information returned to ESA. */
export interface DataDTOShopifyInstallationView {
  /**
   * Shopify application lifecycle status.<p>Possible values:</p>
   * <ul>
   * <li><b>None</b>: No installation lifecycle status has been assigned.</li>
   * <li><b>Installed</b>: The Shopify application is installed on the shop.</li>
   * <li><b>Uninstalled</b>: The Shopify shop has uninstalled the EXO Shopify app.</li>
   * <li><b>Revoked</b>: Shopify access for this installation has been revoked.</li>
   * </ul>
   */
  installationStatus: DataEnumerationsShopifyInstallationStatus;
  /**
   * EXO client-link status.<p>Possible values:</p>
   * <ul>
   * <li><b>Unlinked</b>: The Shopify installation is not linked to an EXO client.</li>
   * <li><b>Linked</b>: The Shopify installation is linked to an EXO client.</li>
   * <li><b>RequiresRelink</b>: The previous EXO client link must be established again.</li>
   * </ul>
   */
  linkStatus: DataEnumerationsShopifyInstallationLinkStatus;
  /** Canonical myshopify.com domain from the Shopify session token. */
  myShopifyDomain: string;
  /**
   * Shopify installation identifier when a row exists.
   * @format uuid
   */
  shopifyInstallationId?: string | null;
  /**
   * EXO client identifier when the shop is linked.
   * @format int32
   */
  clientId?: number | null;
  /** EXO client name when the shop is linked. */
  clientName?: string | null;
  /** EXO-issued JWT for ESA API calls when the installation is active. */
  exoShopifyJwt?: string | null;
  /**
   * Expiration date and time for Stark.EXO.API.Data.DTO.ShopifyInstallationViewDto.ExoShopifyJwt.
   * @format date-time
   */
  exoShopifyJwtExpiresAtUtc?: string | null;
}

/** Request to synchronize granted Shopify access scopes. */
export interface DataDTOShopifyScopeSynchronization {
  /**
   * Canonical Shopify shop domain.
   * @minLength 1
   * @maxLength 255
   */
  shop: string;
  /**
   * Comma-delimited Shopify access scopes.
   * @maxLength 2000
   */
  scope?: string | null;
}

/** Decrypted Shopify session returned by the session-storage API. */
export interface DataDTOShopifySession {
  /** Shopify's unique session identifier. */
  sessionId: string;
  /** Canonical myshopify.com domain for the session. */
  shop: string;
  /** OAuth state associated with the session. */
  state: string;
  /** Indicates whether the session represents an online access token. */
  isOnline: boolean;
  /** Comma-delimited access scopes associated with the session. */
  scope?: string | null;
  /**
   * Date and time when the access token expires.
   * @format date-time
   */
  expiresAtUtc?: string | null;
  /** Decrypted Shopify access token. */
  accessToken?: string | null;
  /** Decrypted Shopify refresh token. */
  refreshToken?: string | null;
  /**
   * Date and time when the refresh token expires.
   * @format date-time
   */
  refreshTokenExpiresAtUtc?: string | null;
  /** JSON representation of Shopify online-access user information. */
  onlineAccessInfoJson?: string | null;
}

/** Complete Shopify session data accepted by the session-storage API. */
export interface DataDTOShopifySessionCrud {
  /**
   * Shopify's unique session identifier.
   * @minLength 1
   * @maxLength 255
   */
  sessionId: string;
  /**
   * Canonical myshopify.com domain for the session.
   * @minLength 1
   * @maxLength 255
   */
  shop: string;
  /**
   * OAuth state associated with an authorization-code session.
   * @maxLength 255
   */
  state?: string | null;
  /** Indicates whether the session represents an online access token. */
  isOnline: boolean;
  /**
   * Comma-delimited access scopes associated with the session.
   * @maxLength 2000
   */
  scope?: string | null;
  /**
   * Date and time when the access token expires.
   * @format date-time
   */
  expiresAtUtc?: string | null;
  /** Plaintext Shopify access token. */
  accessToken?: string | null;
  /** Plaintext Shopify refresh token. */
  refreshToken?: string | null;
  /**
   * Date and time when the refresh token expires.
   * @format date-time
   */
  refreshTokenExpiresAtUtc?: string | null;
  /** JSON representation of Shopify online-access user information. */
  onlineAccessInfoJson?: string | null;
}

/** Result of ensuring that a client's Shopify offline access token is usable. */
export interface DataDTOShopifyTokenRefresh {
  /** Indicates whether this request performed a Shopify token exchange. */
  refreshed: boolean;
  /** Resulting usable Shopify access token and its metadata. */
  token: DataDTOShopifyClientToken;
}

/** Holds information about a sold item in a completed order */
export interface DataDTOSoldItem {
  /** The EPC data */
  primaryIdentifier?: string | null;
  /** Item name snapshot. */
  name?: string | null;
  /**
   * Final per-item price after discounts.
   * @format double
   */
  purchasePrice?: number | null;
  /**
   * Total discount applied to the item.
   * @format double
   */
  discountAmount?: number | null;
  /** The discount type applied to the item. */
  discountType?: DataEnumerationsItemDiscountType | null;
  /**
   * The date and time that the tag was read, including an offset
   * @format date-time
   */
  readTime: string;
  /**
   * The date+time that API received the item information
   * @format date-time
   */
  receivedTime: string;
}

/** Public SSO options for a browser host. */
export interface DataDTOSsoOptions {
  /** Normalized host used for resolution. */
  host: string;
  /**
   * Resolved client id, when the host maps to a client.
   * @format int32
   */
  clientId?: number | null;
  /** Resolved client name, when the host maps to a client. */
  clientName?: string | null;
  /** Resolved client slug, when the host maps to a client. */
  clientSlug?: string | null;
  /** Resolved console kind, when the host maps to a console host. */
  consoleKind?: DataEnumerationsConsoleKind | null;
  /** Public provider display metadata. */
  providers: DataDTOSsoProviderOption[];
  /** Password login remains enabled regardless of SSO provider availability. */
  passwordLoginEnabled: boolean;
}

/** Public provider display metadata. */
export interface DataDTOSsoProviderOption {
  /**
   * Stable provider identifier.
   * @format int32
   */
  id: number;
  /**
   * Provider kind.<p>Possible values:</p>
   * <ul>
   * <li><b>Entra</b>: Microsoft Entra.</li>
   * <li><b>Authentik</b>: Authentik.</li>
   * </ul>
   */
  providerKind: SsoClientSsoProviderKind;
  /** Provider display name. */
  displayName: string;
  /** Login button label. */
  buttonLabel: string;
  /** Optional button background color. */
  displayBackground?: string | null;
  /** Optional button text color. */
  displayColor?: string | null;
}

export interface DataDTOStartStation {
  /** isValidatorApp */
  isValidatorApp: boolean;
}

export interface DataDTOStationConfigurationView {
  /** GlobalSettings */
  globalSettings?: DataDTOStationGlobalSettingsView[] | null;
  /** ServiceAccounts */
  serviceAccounts: string[];
  /** ReadActions */
  readActions: string[];
  /** Stations */
  stations: DataDTOStationDetails[];
  /** RfidReaders */
  rfidReaders: DataDTOStationRfidReaderSettingsView[];
  /** GpioPeripherals */
  gpioPeripherals: DataDTOStationGPIOSettingsView[];
}

export interface DataDTOStationCountList {
  status?: string | null;
  /** @format int32 */
  count?: number | null;
}

/** Station CRUD DTO */
export interface DataDTOStationCrud {
  /**
   * Name
   * @minLength 1
   */
  name: string;
  /** Note */
  note?: string | null;
  /** Status */
  status?: DataEnumerationsStationStatus | null;
  /**
   * ShortCode
   * @minLength 1
   */
  shortCode: string;
  /**
   * stationGroupId
   * @format int32
   */
  stationGroupId: number;
  /**
   * ConfigurationProfileId
   * @format int32
   */
  configurationProfileId: number;
  /**
   * StationType<p>Possible values:</p>
   * <ul>
   * <li><b>Sale</b>: Sales station</li>
   * <li><b>Validator</b>: Validator</li>
   * </ul>
   */
  stationType: DataEnumerationsStationType;
  /** Pos */
  pos?: DataEnumerationsPosSystem | null;
  /** PosApiKey */
  posApiKey?: string | null;
  /** PosDeviceIdentifier */
  posDeviceIdentifier?: string | null;
  /** @format int32 */
  clientId: number;
}

export interface DataDTOStationDetails {
  name?: string | null;
  /** RfidTagMask */
  rfidTagMask?: string | null;
  /** ReaderFirmwareVersion */
  readerFirmwareVersion?: string | null;
  /**
   * CacheTimeout
   * @format int32
   */
  cacheTimeout: number;
  /**
   * Station Type<p>Possible values:</p>
   * <ul>
   * <li><b>Sale</b>: Sales station</li>
   * <li><b>Validator</b>: Validator</li>
   * </ul>
   */
  stationType: DataEnumerationsStationType;
}

/** Data Transfer Object for station registration */
export interface DataDTOStationDeviceAssociationRequest {
  /** The POS API Key */
  apiKey?: string | null;
  /** The POS Device Identifier */
  posDeviceIdentifier?: string | null;
}

/** Data Transfer Object for station registration */
export interface DataDTOStationDeviceAssociationResponse {
  /**
   * The station unique identifier
   * @format uuid
   */
  stationIdentifier: string;
  /** The API Key to use for the station */
  apiKey: string;
  /** The URL for the API */
  url: string;
}

export interface DataDTOStationGPIOSettingsView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /** StringValue */
  stringValue?: string | null;
  /**
   * NumericValue
   * @format float
   */
  numericValue?: number | null;
  /** BooleanValue */
  booleanValue?: boolean | null;
  /**
   * DateValue
   * @format date-time
   */
  dateValue?: string | null;
}

export interface DataDTOStationGlobalSettingsView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /** StringValue */
  stringValue?: string | null;
  /**
   * NumericValue
   * @format float
   */
  numericValue?: number | null;
  /** BooleanValue */
  booleanValue?: boolean | null;
  /**
   * DateValue
   * @format date-time
   */
  dateValue?: string | null;
}

/** StationGroupCrud DTO */
export interface DataDTOStationGroupCrud {
  /**
   * Station Group Name
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /**
   * StoreId
   * @format int32
   */
  storeId: number;
  /**
   * Location of Station Group
   * @minLength 0
   * @maxLength 1000
   */
  locationDescription?: string | null;
  /**
   * Layout
   * @minLength 0
   * @maxLength 255
   */
  layout: string;
  /** Notes */
  notes?: string | null;
  /**
   * Order Fee Percentage
   * @format double
   */
  orderFeePercentage?: number | null;
}

export interface DataDTOStationGroupListing {
  /**
   * Station Group Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /** Location Description */
  locationDescription?: string | null;
  /** Layout */
  layout?: string | null;
  /**
   * ModifiedOn
   * @format date-time
   */
  modifiedOn?: string | null;
  /** ModifiedBy */
  modifiedBy?: string | null;
  /** Is Active */
  isActive: boolean;
  /** Store */
  store?: DataDTOStore | null;
  /**
   * CreatedOn
   * @format date-time
   */
  createdOn?: string | null;
}

export interface DataDTOStationGroupView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * Modified On
   * @format date-time
   */
  modifiedOn?: string | null;
  /**
   * Created On
   * @format date-time
   */
  createdOn?: string | null;
  /** Modified By */
  modifiedBy?: string | null;
  /** Name */
  name?: string | null;
  /** Location Description */
  locationDescription?: string | null;
  /**
   * StoreId
   * @format int32
   */
  storeId: number;
  /** StoreDTO */
  store?: DataDTOStore | null;
  /** Layout */
  layout?: string | null;
  /** Notes */
  notes?: string | null;
  /** Is Active */
  isActive: boolean;
  /**
   * Order Fee Percentage
   * @format double
   */
  orderFeePercentage?: number | null;
}

export interface DataDTOStationHealthStaticsViewData {
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * CurrentCpu
   * @format double
   */
  currentCpu?: number | null;
  /**
   * Memory
   * @format double
   */
  memory?: number | null;
  /**
   * AvailableMemory
   * @format double
   */
  availableMemory?: number | null;
  /** cpuDto */
  cpuDto?: DataDTOHealthStaticsGraph | null;
  /** memoryDto */
  memoryDto?: DataDTOHealthStaticsGraph | null;
}

export interface DataDTOStationHealthView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /**
   * CurrentCpu
   * @format double
   */
  cpu?: number | null;
  /**
   * CurrentMemory
   * @format double
   */
  memory?: number | null;
  /**
   * AvailableMemory
   * @format double
   */
  availableMemory?: number | null;
  /**
   * CurrentThreads
   * @format int32
   */
  threadCount: number;
  /** RfidReaderHealth */
  readerStatus?: DataDTOReaderJson[] | null;
}

export interface DataDTOStationList {
  /** Name */
  name?: string | null;
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * PermanentId
   * @format uuid
   */
  permanentId: string;
  /** The StationGroupName */
  stationGroup?: DataDTOStationGroupView | null;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /** StationMode */
  stationMode?: DataEnumerationsStationMode | null;
  /** Status */
  status?: DataEnumerationsStationStatus | null;
  /** Alert */
  alert?: DataDTOAlert | null;
  /** Station Id */
  shortCode?: string | null;
  /** Notes */
  note?: string | null;
  /**
   * CreatedOn
   * @format date-time
   */
  createdOn?: string | null;
  /**
   * ConfigurationProfileId
   * @format int32
   */
  configurationProfileId: number;
  /**
   * Station Type<p>Possible values:</p>
   * <ul>
   * <li><b>Sale</b>: Sales station</li>
   * <li><b>Validator</b>: Validator</li>
   * </ul>
   */
  stationType: DataEnumerationsStationType;
  /** Pos */
  pos?: DataEnumerationsPosSystem | null;
  /** PosApiKey */
  posApiKey?: string | null;
  /** Station's machine name */
  machineName?: string | null;
  /** PosDeviceIdentifier */
  posDeviceIdentifier?: string | null;
  /**
   * The ID of the current order associated with the station
   * @format int32
   */
  currentOrderId?: number | null;
}

/** Station Listing DTO */
export interface DataDTOStationListing {
  /** Name */
  name?: string | null;
  /** Note */
  note?: string | null;
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /** Status */
  status?: DataEnumerationsStationStatus | null;
  /** operatingMode */
  operatingMode?: string | null;
  stationGroup?: DataDTOStationGroupView | null;
}

/** Station Profile CRUD DTO */
export interface DataDTOStationProfileCrud {
  /** ConfigurationSettingValueOverride */
  globalConfigurationSetting: DataDTOGlobalProfileSettingValueOverride[];
  /** GpioConfigurationSettingValueOverride */
  gpioConfigurationSetting: DataDTOGpioConfigurationSettingValueOverride[];
  /** RfidReaderConfigurationOverrideDto */
  rfidReaderConfiguration: DataDTOReaderOverride[];
}

export interface DataDTOStationRegistryCrud {
  /**
   * Access Code of Station
   * @minLength 1
   */
  accessCode: string;
  /**
   * StationId
   * @format int32
   */
  stationId: number;
  /**
   * PermanentId
   * @format uuid
   */
  permanentId: string;
  /**
   * Access Uri
   * @minLength 1
   */
  accessUri: string;
  /**
   * Access Token
   * @minLength 1
   */
  accessToken: string;
}

export interface DataDTOStationRegistryView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Access Code of Station */
  accessCode?: string | null;
  /**
   * StationId
   * @format int32
   */
  stationId: number;
  /**
   * PermanentId
   * @format uuid
   */
  permanentId?: string | null;
  /** Access Uri */
  accessUri?: string | null;
  /** Access Token */
  accessToken?: string | null;
}

export interface DataDTOStationRfidReaderSettingsView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** ReaderName */
  name?: string | null;
  /** ReaderModel */
  readerModel?: string | null;
  /** IpAddress */
  ipAddress?: string | null;
  /**
   * Port
   * @format int32
   */
  port: number;
  /**
   * PowerLevel
   * @format int32
   */
  powerLevel: number;
  /**
   * Session
   * @format int32
   */
  session: number;
  /**
   * MinRssi
   * @format int32
   */
  minRssi: number;
  /**
   * MinStreamReadCount
   * @format int32
   */
  minStreamReadCount: number;
  /**
   * ReadCountPersistTime
   * @format int32
   */
  readCountPersistTime: number;
  /** SearchMode */
  searchMode?: string | null;
  /** Enabled */
  enabled?: boolean | null;
  /**
   * AntennaDwellTime
   * @format int32
   */
  antennaDwellTime?: number | null;
  /** AntennaConfiguration */
  antennas?: DataDTOAntennaDetailsView[] | null;
}

export interface DataDTOStationStatus {
  /**
   * The current status of the station, indicating if the station is
   * in use, ready, disconnected, etc.
   */
  status?: DataEnumerationsStationStatus | null;
}

export interface DataDTOStationSummary {
  /** @format int32 */
  id: number;
  /**
   * StationId
   * @format int32
   */
  stationId?: number | null;
  /**
   * DateTime
   * @format date-time
   */
  dateTime?: string | null;
  /** Total Items */
  totalItems: DataDTOStationSummaryItem;
  /** Total Orders */
  totalOrders: DataDTOStationSummaryItem;
  /** Reads Average */
  readsAverage: DataDTOStationSummaryItemRead;
}

export interface DataDTOStationSummaryItem {
  /**
   * Count
   * @format int32
   */
  count: number;
  /** Delta Direction */
  deltaDirection?: boolean | null;
  /**
   * Delta Difference
   * @format int32
   */
  deltaDifference?: number | null;
}

export interface DataDTOStationSummaryItemRead {
  /**
   * Count
   * @format double
   */
  count: number;
  /** Delta Direction */
  deltaDirection?: boolean | null;
  /**
   * Delta Difference
   * @format double
   */
  deltaDifference?: number | null;
}

/** Station View DTO */
export interface DataDTOStationView {
  /** The name of the station */
  name?: string | null;
  /** Additional information captured about the station. */
  note?: string | null;
  /** Free-form text that describes the current status of the station. */
  status: string;
  /** The current order associated with this station */
  currentOrder?: DataDTOOrderView | null;
  /**
   * The ID of the current order associated with the station
   * @format int32
   */
  currentOrderId?: number | null;
  /**
   * The entity ID
   * @format int32
   */
  id: number;
  /**
   * The date and time the entity was last modified
   * @format date-time
   */
  modifiedOn?: string | null;
  /** The username who last modified this entity */
  modifiedBy?: string | null;
  /**
   * The ID of the base configuration profile associated with the station.
   * @format int32
   */
  configurationProfileId: number;
  /**
   * The type of station (Sales, Validator)<p>Possible values:</p>
   * <ul>
   * <li><b>Sale</b>: Sales station</li>
   * <li><b>Validator</b>: Validator</li>
   * </ul>
   */
  stationType: DataEnumerationsStationType;
  /**
   * Globally unique value used to identify the station. This value is provided to POS vendors by EXO.
   * @format uuid
   */
  permanentId?: string | null;
  /** The active alert condition on the station, if any */
  alert?: DataDTOAlert | null;
  /** The POS associated with the station. */
  pos?: DataEnumerationsPosSystem | null;
  /** The API key or authorization token used to interact with the POS. */
  posApiKey?: string | null;
  /** The computer name / hostname of the station */
  machineName?: string | null;
  /** Station Group Details */
  stationGroup?: DataDTOStationGroupView | null;
  /** PosDeviceIdentifier */
  posDeviceIdentifier?: string | null;
  /** ReaderHealthStatus */
  readerHealthStatus?: DataDTORfidReaderHealthView[] | null;
}

/** Store DTO */
export interface DataDTOStore {
  /**
   * Store Id
   * @format int32
   */
  id: number;
  /** Store Name */
  name: string;
  /** Store UniqueId */
  code: string;
  /** Contact Email */
  email?: string | null;
  /** Contact Phone */
  phone?: string | null;
  /** Contact Name */
  contactName?: string | null;
  /** Notes */
  notes?: string | null;
  /**
   * Client Id
   * @format int32
   */
  clientId: number;
  /** Clients */
  client?: DataDTOClientView | null;
  /** IsActive */
  isActive: boolean;
  /** Address */
  address?: DataDTOStoreAddressCrud | null;
  /** Timezone */
  timezone: string;
  /** Determines if a station should start listening unless triggered by the ToF sensor */
  startListeningOnlyViaTrigger: boolean;
  /**
   * Defines the period of time, in seconds, that purchased or new items will be prevented
   * from being added to a different order.
   * @format int32
   */
  purchasedItemTimeoutPeriodInSeconds?: number | null;
  /**
   * Determines how long before an order is considered "idle" and should be closed.
   * @format int32
   */
  orderIdleTimeoutInMinutes?: number | null;
  /**
   * A generic place to store configuration data
   * @maxLength 200
   */
  data1?: string | null;
  /**
   * Another generic place to store configuration data
   * @maxLength 200
   */
  data2?: string | null;
  /** Yet another generic place to store configuration data */
  data3?: string | null;
  /**
   * Determines when discount-code entry is available and required.<p>Possible values:</p>
   * <ul>
   * <li><b>Disabled</b>: The feature is unavailable and never blocks checkout.</li>
   * <li><b>RequiredPreOrder</b>: The lookup must succeed before the patron can begin shopping.</li>
   * <li><b>OptionalPreOrderRequiredAtCheckout</b>: The lookup is offered before shopping and becomes required before Review.</li>
   * <li><b>RequiredAtCheckout</b>: The lookup must succeed before the order can move to Review.</li>
   * <li><b>OptionalPostAttract</b>: The lookup is optionally available after the attract screen.</li>
   * </ul>
   */
  discountCodeMode: DataEnumerationsLookupMode;
  /** Gets or sets the POS system supported by the discount-code configuration. */
  discountCodePosSystem?: DataEnumerationsPosSystem | null;
  /** Gets or sets the system responsible for applying discount codes. */
  discountCodeProvider?: DataEnumerationsDiscountCodeProvider | null;
  /**
   * Gets or sets the maximum number of unsuccessful discount-code attempts.
   * @format int32
   */
  discountCodeMaximumAttempts?: number | null;
  /**
   * Gets or sets the beginning of the discount-code configuration's active window.
   * @format date-time
   */
  discountCodeActiveFrom?: string | null;
  /**
   * Gets or sets the end of the discount-code configuration's active window.
   * @format date-time
   */
  discountCodeActiveTo?: string | null;
  /** Gets or sets the Checkout button label for discount-code entry. */
  discountCodeButtonLabel?: string | null;
  /** Gets or sets the Checkout button color for discount-code entry. */
  discountCodeButtonColor?: string | null;
  /** Gets or sets the message displayed after a discount code succeeds. */
  discountCodeSuccessMessage?: string | null;
  /** Gets or sets the message displayed after a discount code fails. */
  discountCodeFailureMessage?: string | null;
  /**
   * Determines when loyalty-program lookup is available and required.<p>Possible values:</p>
   * <ul>
   * <li><b>Disabled</b>: The feature is unavailable and never blocks checkout.</li>
   * <li><b>RequiredPreOrder</b>: The lookup must succeed before the patron can begin shopping.</li>
   * <li><b>OptionalPreOrderRequiredAtCheckout</b>: The lookup is offered before shopping and becomes required before Review.</li>
   * <li><b>RequiredAtCheckout</b>: The lookup must succeed before the order can move to Review.</li>
   * <li><b>OptionalPostAttract</b>: The lookup is optionally available after the attract screen.</li>
   * </ul>
   */
  loyaltyProgramMode: DataEnumerationsLookupMode;
  /** Gets or sets the POS system supported by the explicit loyalty configuration. */
  loyaltyProgramPosSystem?: DataEnumerationsPosSystem | null;
  /** Gets or sets the explicitly configured loyalty-program provider. */
  loyaltyProgramProvider?: DataEnumerationsLoyaltyProgramProvider | null;
  /**
   * Gets or sets the maximum number of unsuccessful loyalty lookup attempts.
   * @format int32
   */
  loyaltyProgramMaximumAttempts?: number | null;
  /**
   * Gets or sets the beginning of the loyalty configuration's active window.
   * @format date-time
   */
  loyaltyProgramActiveFrom?: string | null;
  /**
   * Gets or sets the end of the loyalty configuration's active window.
   * @format date-time
   */
  loyaltyProgramActiveTo?: string | null;
  /** Gets or sets the Checkout button label for loyalty lookup. */
  loyaltyProgramButtonLabel?: string | null;
  /** Gets or sets the Checkout button color for loyalty lookup. */
  loyaltyProgramButtonColor?: string | null;
  /** Gets or sets the message displayed after a loyalty lookup succeeds. */
  loyaltyProgramSuccessMessage?: string | null;
  /** Gets or sets the message displayed after a loyalty lookup fails. */
  loyaltyProgramFailureMessage?: string | null;
  /** Gets or sets the provider API hostname used by the Order Processor. */
  loyaltyProgramHostname?: string | null;
  /** Gets or sets a value indicating whether a protected provider username is configured. */
  hasLoyaltyProgramUsername: boolean;
  /** Gets or sets a value indicating whether a protected provider password is configured. */
  hasLoyaltyProgramPassword: boolean;
}

/** Store Address */
export interface DataDTOStoreAddressCrud {
  /**
   * Address 1
   * @minLength 0
   * @maxLength 255
   */
  address1?: string | null;
  /**
   * Address2
   * @minLength 0
   * @maxLength 255
   */
  address2?: string | null;
  /**
   * City
   * @minLength 0
   * @maxLength 50
   */
  city?: string | null;
  /**
   * State
   * @minLength 0
   * @maxLength 50
   */
  state?: string | null;
  /**
   * Zip
   * @minLength 0
   * @maxLength 6
   */
  zip?: string | null;
  /**
   * Store ID
   * @format int32
   */
  storeId: number;
}

export interface DataDTOStoreCrud {
  /**
   * Store Name
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /** Contact Person Name */
  contactName?: string | null;
  /**
   * Phone
   * @minLength 0
   * @maxLength 20
   */
  phone?: string | null;
  /**
   * Email
   * @minLength 0
   * @maxLength 255
   */
  email?: string | null;
  /** Notes */
  notes?: string | null;
  /**
   * Code
   * @maxLength 200
   */
  code?: string | null;
  /** Store Address */
  address?: DataDTOStoreAddressCrud | null;
  /**
   * Timezone
   * @minLength 1
   * @maxLength 255
   */
  timezone: string;
  /**
   * Pin
   * @minLength 0
   * @maxLength 200
   */
  pin?: string | null;
  /** @format int32 */
  clientId: number;
  /** Determines if a station should start listening unless triggered by the ToF sensor */
  startListeningOnlyViaTrigger: boolean;
  /**
   * Defines the period of time, in seconds, that purchased or new items will be prevented
   * from being added to a different order.
   * @format int32
   */
  purchasedItemTimeoutPeriodInSeconds?: number | null;
  /**
   * Determines how long before an order is considered "idle" and should be closed.
   * @format int32
   */
  orderIdleTimeoutInMinutes?: number | null;
  /**
   * A generic place to store configuration data
   * @maxLength 200
   */
  data1?: string | null;
  /**
   * Another generic place to store configuration data
   * @maxLength 200
   */
  data2?: string | null;
  /** Yet another generic place to store configuration data */
  data3?: string | null;
  /**
   * Determines when discount-code entry is available and required.<p>Possible values:</p>
   * <ul>
   * <li><b>Disabled</b>: The feature is unavailable and never blocks checkout.</li>
   * <li><b>RequiredPreOrder</b>: The lookup must succeed before the patron can begin shopping.</li>
   * <li><b>OptionalPreOrderRequiredAtCheckout</b>: The lookup is offered before shopping and becomes required before Review.</li>
   * <li><b>RequiredAtCheckout</b>: The lookup must succeed before the order can move to Review.</li>
   * <li><b>OptionalPostAttract</b>: The lookup is optionally available after the attract screen.</li>
   * </ul>
   */
  discountCodeMode: DataEnumerationsLookupMode;
  /** Gets or sets the POS system supported by the discount-code configuration. */
  discountCodePosSystem?: DataEnumerationsPosSystem | null;
  /** Gets or sets the system responsible for applying discount codes. */
  discountCodeProvider?: DataEnumerationsDiscountCodeProvider | null;
  /**
   * Gets or sets the maximum number of unsuccessful discount-code attempts.
   * @format int32
   */
  discountCodeMaximumAttempts?: number | null;
  /**
   * Gets or sets the beginning of the discount-code configuration's active window.
   * @format date-time
   */
  discountCodeActiveFrom?: string | null;
  /**
   * Gets or sets the end of the discount-code configuration's active window.
   * @format date-time
   */
  discountCodeActiveTo?: string | null;
  /**
   * Gets or sets the Checkout button label for discount-code entry.
   * @minLength 0
   * @maxLength 200
   */
  discountCodeButtonLabel?: string | null;
  /**
   * Gets or sets the Checkout button color for discount-code entry.
   * @minLength 0
   * @maxLength 50
   */
  discountCodeButtonColor?: string | null;
  /**
   * Gets or sets the message displayed after a discount code succeeds.
   * @minLength 0
   * @maxLength 1000
   */
  discountCodeSuccessMessage?: string | null;
  /**
   * Gets or sets the message displayed after a discount code fails.
   * @minLength 0
   * @maxLength 1000
   */
  discountCodeFailureMessage?: string | null;
  /**
   * Determines when loyalty-program lookup is available and required.<p>Possible values:</p>
   * <ul>
   * <li><b>Disabled</b>: The feature is unavailable and never blocks checkout.</li>
   * <li><b>RequiredPreOrder</b>: The lookup must succeed before the patron can begin shopping.</li>
   * <li><b>OptionalPreOrderRequiredAtCheckout</b>: The lookup is offered before shopping and becomes required before Review.</li>
   * <li><b>RequiredAtCheckout</b>: The lookup must succeed before the order can move to Review.</li>
   * <li><b>OptionalPostAttract</b>: The lookup is optionally available after the attract screen.</li>
   * </ul>
   */
  loyaltyProgramMode: DataEnumerationsLookupMode;
  /** Gets or sets the POS system supported by the explicit loyalty configuration. */
  loyaltyProgramPosSystem?: DataEnumerationsPosSystem | null;
  /** Gets or sets the explicitly configured loyalty-program provider. */
  loyaltyProgramProvider?: DataEnumerationsLoyaltyProgramProvider | null;
  /**
   * Gets or sets the maximum number of unsuccessful loyalty lookup attempts.
   * @format int32
   */
  loyaltyProgramMaximumAttempts?: number | null;
  /**
   * Gets or sets the beginning of the loyalty configuration's active window.
   * @format date-time
   */
  loyaltyProgramActiveFrom?: string | null;
  /**
   * Gets or sets the end of the loyalty configuration's active window.
   * @format date-time
   */
  loyaltyProgramActiveTo?: string | null;
  /**
   * Gets or sets the Checkout button label for loyalty lookup.
   * @minLength 0
   * @maxLength 200
   */
  loyaltyProgramButtonLabel?: string | null;
  /**
   * Gets or sets the Checkout button color for loyalty lookup.
   * @minLength 0
   * @maxLength 50
   */
  loyaltyProgramButtonColor?: string | null;
  /**
   * Gets or sets the message displayed after a loyalty lookup succeeds.
   * @minLength 0
   * @maxLength 1000
   */
  loyaltyProgramSuccessMessage?: string | null;
  /**
   * Gets or sets the message displayed after a loyalty lookup fails.
   * @minLength 0
   * @maxLength 1000
   */
  loyaltyProgramFailureMessage?: string | null;
  /**
   * Gets or sets the provider API hostname used by the Order Processor.
   * @minLength 0
   * @maxLength 2048
   */
  loyaltyProgramHostname?: string | null;
  /**
   * Gets or sets a new plaintext provider username to protect during this write.
   * @minLength 0
   * @maxLength 1000
   */
  loyaltyProgramUsername?: string | null;
  /**
   * Gets or sets a new plaintext provider password to protect during this write.
   * @minLength 0
   * @maxLength 1000
   */
  loyaltyProgramPassword?: string | null;
  /** Gets or sets a value indicating whether the existing protected username must be cleared. */
  clearLoyaltyProgramUsername: boolean;
  /** Gets or sets a value indicating whether the existing protected password must be cleared. */
  clearLoyaltyProgramPassword: boolean;
}

export interface DataDTOStoreList {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
}

/** Store Listing */
export interface DataDTOStoreListing {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Name */
  name?: string | null;
  /** ContactName */
  contactName?: string | null;
  /** ContactEmail */
  email?: string | null;
  /** ContactPhone */
  phone?: string | null;
  /**
   * ClientId
   * @format int32
   */
  clientId?: number | null;
  /** IsActive */
  isActive: boolean;
  /**
   * CreatedOn
   * @format date-time
   */
  createdOn?: string | null;
  /** Address */
  address?: DataDTOStoreAddressCrud | null;
  /** Timezone */
  timezone: string;
  /** IanaTimezone */
  ianaTimezone: string;
  /** Determines if a station should start listening unless triggered by the ToF sensor */
  startListeningOnlyViaTrigger: boolean;
  /**
   * Defines the period of time, in seconds, that purchased or new items will be prevented
   * from being added to a different order.
   * @format int32
   */
  purchasedItemTimeoutPeriodInSeconds?: number | null;
  /**
   * Determines how long before an order is considered "idle" and should be closed.
   * @format int32
   */
  orderIdleTimeoutInMinutes?: number | null;
}

/** System Message CRUD DTO */
export interface DataDTOSystemMessageCrud {
  /**
   * ClientId
   * @format int32
   */
  clientId?: number | null;
  /** Status */
  data?: string | null;
  /**
   * Error
   * @maxLength 255
   */
  message: string;
  /**
   * SourceSystem
   * @maxLength 255
   */
  sourceSystem: string;
  /**
   * MessageType<p>Possible values:</p>
   * <ul>
   * <li><b>Import</b>: Import</li>
   * <li><b>Order</b>: Order</li>
   * <li><b>Transaction</b>: Transaction</li>
   * <li><b>Payment</b>: Payment</li>
   * </ul>
   */
  messageType: DataEnumerationsSystemMessageType;
  /**
   * Level<p>Possible values:</p>
   * <ul>
   * <li><b>Error</b>: Error</li>
   * <li><b>Information</b>: Information</li>
   * <li><b>Warning</b>: Warning</li>
   * </ul>
   */
  level: DataEnumerationsSystemMessageLevel;
}

/** System Message DTO */
export interface DataDTOSystemMessageView {
  /**
   * SystemMessage Id
   * @format int32
   */
  id: number;
  /**
   * ClientId
   * @format int32
   */
  clientId?: number | null;
  /** Error */
  message: string;
  /** SourceSystem */
  sourceSystem: string;
  /**
   * MessageType<p>Possible values:</p>
   * <ul>
   * <li><b>Import</b>: Import</li>
   * <li><b>Order</b>: Order</li>
   * <li><b>Transaction</b>: Transaction</li>
   * <li><b>Payment</b>: Payment</li>
   * </ul>
   */
  messageType: DataEnumerationsSystemMessageType;
  /**
   * Level<p>Possible values:</p>
   * <ul>
   * <li><b>Error</b>: Error</li>
   * <li><b>Information</b>: Information</li>
   * <li><b>Warning</b>: Warning</li>
   * </ul>
   */
  level: DataEnumerationsSystemMessageLevel;
  /**
   * CreatedOn
   * @format date-time
   */
  createdOn: string;
}

export interface DataDTOTaxAndDiscountTotal {
  /** @format double */
  discountTotalAmount?: number | null;
  /**
   * Order-level discount amount (separate from line item discounts).
   * @format double
   */
  orderDiscountAmount?: number | null;
  /** @format double */
  taxAmount?: number | null;
  /**
   * This will contain Fee amount if it exists
   * @format double
   */
  fee1?: number | null;
  /**
   * This will contain another Fee amount if it exists
   * @format double
   */
  fee2?: number | null;
  /**
   * This will contain yet another Fee amount if it exists
   * @format double
   */
  fee3?: number | null;
  /**
   * The order base amount - equivalent to the sum of items at full price.
   * No taxes, fees, or discounts are taken into account.
   * @format double
   */
  baseAmount?: number | null;
  /**
   * The subtotal amount before tax
   * @format double
   */
  subTotalAmount?: number | null;
  /**
   * The grand total amount after tax, fees, and discounts
   * @format double
   */
  grandTotalAmount?: number | null;
  /**
   * The total of all fees
   * @format double
   */
  feeTotalAmount?: number | null;
  /**
   * Tax percentage applied to this order.
   * @format double
   */
  taxPercentage?: number | null;
  /** Optional line item pricing/discount updates. */
  items?: DataDTOTaxAndDiscountTotalItem[] | null;
}

/** Line item pricing/discount updates used with TaxAndDiscountTotal updates. */
export interface DataDTOTaxAndDiscountTotalItem {
  /**
   * The EXO Item Id.
   * @format int32
   */
  itemId?: number | null;
  /** The EPC data. */
  epc?: string | null;
  /** Product external identifier. */
  externalId?: string | null;
  /** Stock Keeping Unit. */
  sku?: string | null;
  /**
   * Final per-item price after discounts.
   * @format double
   */
  purchasePrice?: number | null;
  /**
   * Total discount applied to the item.
   * @format double
   */
  discountAmount?: number | null;
  /** The discount type applied to the item. */
  discountType?: DataEnumerationsItemDiscountType | null;
  /** Discount description. */
  discountDescription?: string | null;
  /** Discount title. */
  discountTitle?: string | null;
  /** Item name snapshot. */
  name?: string | null;
}

/** System Timezone Information */
export interface DataDTOTimezoneInfo {
  /** Timezone ID */
  id: string;
  /** Display Name */
  name: string;
}

export interface DataDTOTransactionHistory {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** StoreName */
  storeName?: string | null;
  /** StationGroupName */
  stationGroupName?: string | null;
  /** StationName */
  stationName?: string | null;
  /**
   * Transaction Start DateTime
   * @format date-time
   */
  createdOn: string;
  /**
   * ItemsCount
   * @format int32
   */
  itemsCount: number;
  /** ExternalId */
  externalId?: string | null;
  /** ReferenceNumber */
  referenceNumber?: string | null;
  /**
   * ReadDuration
   * @format double
   */
  readDuration: number;
  /** VoidedFrom */
  voidedFrom?: string | null;
  /** Status */
  status?: DataEnumerationsOrderStatus | null;
  /**
   * StartedAt
   * @format date-time
   */
  startedAt: string;
  /**
   * CompletedAt
   * @format date-time
   */
  completedAt?: string | null;
  /**
   * count for items only for voided false , excluded voided and unknown and deactivated items
   * @format int32
   */
  validItemCount: number;
  /** Payment type */
  creditType?: string | null;
  /**
   * User that approved the cash transaction
   * @format int32
   */
  cashierUserId?: number | null;
  /** First name of the user that approved the cash transaction */
  cashierFirstName?: string | null;
  /** Last name of the user that approved the cash transaction */
  cashierLastName?: string | null;
  /**
   * Time the cash transaction was approved
   * @format date-time
   */
  cashApprovedAt?: string | null;
  /**
   * Cash collected for the transaction
   * @format double
   */
  cashCollectedAmount?: number | null;
  /** List of Items for this Transaction */
  items: DataDTOOrderHistoryItems[];
}

export interface DataDTOTransactionSummary {
  /**
   * CompletedTransactionCount
   * @format int32
   */
  completedTransactionCount: number;
  /**
   * ItemsPerTransaction
   * @format double
   */
  averagePurchasedItems: number;
  /**
   * ItemsPerTransaction
   * @format double
   */
  averageScanDuration: number;
  /**
   * AverageTransactionDuration
   * @format double
   */
  averageTransactionDuration: number;
  /**
   * AveragePaymentDuration
   * @format double
   */
  averagePaymentDuration: number;
  /** @format double */
  averageItems: number;
}

/** Holds information related to generating a signed JWT for Treez API / Treez PaySDK Widget */
export interface DataDTOTreezAuth {
  /** The target resource */
  targetUrl?: string | null;
  /**
   * The Certificate ID
   * @format uuid
   */
  certificateId: string;
  /**
   * Organization ID
   * @format uuid
   */
  organizationId: string;
}

/** Holds information related to generating a signed JWT for Treez API / Treez PaySDK Widget */
export interface DataDTOTreezAuthResponse {
  /** The Access Token to use */
  accessToken: string;
}

export interface DataDTOTunnel {
  /** @format int32 */
  id: number;
  /** @format uuid */
  permanentId?: string | null;
  name?: string | null;
  /** @format int32 */
  locationId: number;
  notes?: string | null;
  isActive: boolean;
  isDeleted: boolean;
  /** @format date-time */
  createdOn: string;
  /** @format date-time */
  modifiedOn: string;
  createdBy?: string | null;
  modifiedBy?: string | null;
  /** @format int32 */
  version?: number | null;
  tunnelCode?: string | null;
  location?: DataDTOLocation | null;
}

export interface DataDTOTunnelCrud {
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /** @format int32 */
  locationId: number;
  notes?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  tunnelCode?: string | null;
  isActive: boolean;
}

export interface DataDTOTunnelUpdate {
  /**
   * @minLength 0
   * @maxLength 255
   */
  name: string;
  /** @format int32 */
  locationId: number;
  notes?: string | null;
  /**
   * @minLength 0
   * @maxLength 255
   */
  tunnelCode?: string | null;
  isActive: boolean;
  isDeleted: boolean;
}

export interface DataDTOUnknownItemView {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** Epc */
  primaryIdentifier?: string | null;
  /** Upc value FE use as DecodedEpc */
  upc?: string | null;
  /** StationName */
  stationName?: string | null;
  /**
   * ReadDuration
   * @format date-time
   */
  receivedTime?: string | null;
  /** ExternalId */
  externalId?: string | null;
  /** ReferenceNumber */
  referenceNumber?: string | null;
  /**
   * Transaction Start DateTime
   * @format date-time
   */
  createdOn: string;
  /** Determines if an item is void in the system. */
  itemStatus?: DataEnumerationsItemStatus | null;
  captureMethod?: DataEnumerationsItemCaptureMethod | null;
}

/** User Account Requirements Information */
export interface DataDTOUserAccountInfo {
  /** Human-readable username requirements */
  usernameFriendlyRequirements?: string | null;
  /** Allowed characters in the username */
  allowedUsernameCharacters?: string | null;
  /**
   * Required password length
   * @format int32
   */
  requiredLength?: number | null;
  /** Password requires digits? */
  requiresDigits?: boolean | null;
  /** Password requires lower case letters? */
  requiresLowerCase?: boolean | null;
  /** Password requires upper case letters? */
  requiresUpperCase?: boolean | null;
  /** Password requires non-alphanumeric characters? */
  requiresNonAlphanumeric?: boolean | null;
  /** Will username be used for logging in? */
  isUsernameEmail?: boolean | null;
  /** Is email required to be unique? */
  uniqueEmail?: boolean | null;
}

export interface DataDTOUserAlertNotification {
  /**
   * Id
   * @format int32
   */
  id: number;
  /** SuperAdmin */
  superAdmin?: string | null;
  /** ClientAdmin */
  clientAdmin?: string | null;
  /** StoreManager */
  storeManager?: string | null;
  /** FloorManager */
  floorManager?: string | null;
  /** Clerk */
  clerk?: string | null;
  /** AlertType */
  alertType?: DataEnumerationsAlertType | null;
}

export interface DataDTOUserChangePassword {
  /** @minLength 1 */
  currentPassword: string;
  /** @minLength 1 */
  newPassword: string;
  confirmPassword: string;
}

export interface DataDTOUserCrud {
  /**
   * Username
   * @minLength 1
   */
  username: string;
  /**
   * Email
   * @format email
   * @minLength 1
   */
  email: string;
  /**
   * FirstName
   * @minLength 0
   * @maxLength 255
   */
  firstName: string;
  /**
   * LastName
   * @minLength 0
   * @maxLength 255
   */
  lastName: string;
  /** Start Page */
  startPage?: string | null;
  /**
   * If set, this user will be unable to access any other route in the application than their start page.
   * This can be used to create kiosk-style access or specialized reporting views.
   */
  lockToStartPage?: boolean | null;
  /**
   * Employee PIN used to identify the user for cash-order authorization.
   * @minLength 0
   * @maxLength 100
   */
  employeePin?: string | null;
  newPassword?: string | null;
  confirmPassword?: string | null;
  /** UserRoles */
  userRoles: string[];
  /** UserStores */
  userStores: number[];
  /**
   * PhoneNo
   * @minLength 0
   * @maxLength 20
   */
  phoneNumber?: string | null;
  /** Notes */
  notes?: string | null;
  /** @format int32 */
  clientId?: number | null;
}

export interface DataDTOUserForgotPassword {
  /** @minLength 1 */
  username: string;
}

export interface DataDTOUserInitialize {
  /** @minLength 1 */
  challenge: string;
  /** @minLength 1 */
  username: string;
  /** @minLength 1 */
  firstname: string;
  /** @minLength 1 */
  lastname: string;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @minLength 1 */
  password: string;
}

export interface DataDTOUserListing {
  /**
   * User ID
   * @format int32
   */
  id: number;
  /** Firstname */
  firstName: string;
  /** Last name */
  lastName: string;
  /** Username */
  username: string;
  email: string;
  userRoles: string[];
  /** Policies supported by the user's roles. */
  policies?: string[] | null;
  /** PhoneNumber */
  phoneNumber: string;
  /** IsActive */
  isActive: boolean;
  /**
   * CreatedOn
   * @format date-time
   */
  createdOn?: string | null;
  /** UserStore */
  userStores: DataDTOStoreList[];
}

export interface DataDTOUserLogin {
  /** GrantType */
  grantType?: string | null;
  /** RefreshToken */
  refreshToken?: string | null;
  /** Username */
  username: string;
  /** Password */
  password: string;
  /**
   * Remember me
   * If set, change token expiration to 5 days from 3 hours
   */
  rememberMe: boolean;
}

export interface DataDTOUserProfileCrud {
  /** Firstname */
  firstName: string;
  /** Last name */
  lastName: string;
  /** Username */
  username: string;
  email: string;
}

export interface DataDTOUserResetPassword {
  /** @minLength 1 */
  username: string;
  /** @minLength 1 */
  password: string;
  confirmPassword: string;
  token: string;
}

export interface DataDTOUserRoleListing {
  /** @format int32 */
  id: number;
  name?: string | null;
}

export interface DataDTOUserStartPage {
  /** The route to send the user to when logged in */
  startPage?: string | null;
}

export interface DataDTOUserTokenData {
  /** Token */
  token?: string | null;
  /**
   * Expiration
   * @format date-time
   */
  expiration?: string | null;
  /** RefreshToken */
  refreshToken?: string | null;
  /** Id */
  id?: string | null;
  /** Roles */
  roles?: string[] | null;
  /** Policies supported by the user's roles. */
  policies?: string[] | null;
  /** StartPage */
  startPage?: string | null;
  /** LockToStartPage */
  lockToStartPage?: boolean | null;
  userName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface DataDTOUserView {
  /**
   * User ID
   * @format int32
   */
  id: number;
  /** Firstname */
  firstName?: string | null;
  /** Last name */
  lastName?: string | null;
  /** Username */
  username?: string | null;
  /** Email */
  email?: string | null;
  /** Start Page */
  startPage?: string | null;
  /**
   * If set, this user will be unable to access any other route in the application than their start page.
   * This can be used to create kiosk-style access or specialized reporting views.
   */
  lockToStartPage?: boolean | null;
  /** Employee PIN used to identify the user for cash-order authorization. */
  employeePin?: string | null;
  /** UserRoles */
  userRoles?: string[] | null;
  /** PhoneNumber */
  phoneNumber?: string | null;
  /** Notes */
  notes?: string | null;
  /** UserStores */
  userStores: DataDTOStoreList[];
}

export interface DataDTOVoidTransaction {
  /** item */
  item?: string | null;
  /** voidedFrom */
  voidedFrom?: string | null;
}

export type JToken = JToken[];

export interface NameAndId {
  name?: string | null;
  id?: string | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface StructuredTag {
  data?: string | null;
  isValidSchema: boolean;
  primaryIdentifier: string;
  readOnlyIdentifier?: string | null;
  /** @format int64 */
  serialNumber?: number | null;
  upc?: string | null;
}

/** System Status displayed in the API status page */
export interface SystemStatusSystemStatus {
  /** Deployment */
  deployment?: string | null;
  /**
   * When the app started up
   * @format date-time
   */
  startupTime: string;
  /** Version */
  version?: string | null;
}
